import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instance104q5opgivhr8 as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance2dy62s6vvg5md as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  CancellationException3b36o9qz53rgr as CancellationException,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspended1qp7gd6asibpv as returnIfSuspended,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  getOrNull1go7ef9ldk0df as getOrNull,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  coerceAtMost322komnqp70ag as coerceAtMost,
  contains1tccixv8iwdcq as contains,
  listOfvhqybd2zx248 as listOf,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_0,
  Companion_getInstance15h5aaybcsdep as Companion_getInstance_1,
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Companion_instance2bvf2vakw640b as Companion_instance_0,
  Injectorxjyp19tp5mfu as Injector,
  Colors_getInstance1qvds1isfbag2 as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2cnrrhh9rakoc as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf63jsbsnnrny7w3 as RGBA__hashCode_impl_h59qf6,
  Companion_getInstance19z3k1g06rka6 as Companion_getInstance_2,
  Companion_getInstance21plr7f541fx9 as Companion_getInstance_3,
  Companion_getInstancech3bi94cc2ym as Companion_getInstance_4,
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  Companion_getInstancew949xxob44bw as Companion_getInstance_5,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_6,
  PerformanceCounter_getInstance23wo5gavc7ilf as PerformanceCounter_getInstance,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  readBitmap1dn2o52mvbpv4 as readBitmap,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
  InjectorContextps0ngmjb9onz as InjectorContext,
  Companion_instance3c5rz779n238s as Companion_instance_1,
  Dyn__set_impl_2ozvx82r2n5zj0vrm3z as Dyn__set_impl_2ozvx8,
  Companion_instance2mxqoacslm62w as Companion_instance_2,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance1fqld9q4wfq20 as Companion_instance_3,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance3moaeo8p2fvjj as Companion_getInstance_7,
  DateTime2gld4ho36azq9 as DateTime,
  Level_TRACE_getInstance3v3hjwgnnbwb6 as Level_TRACE_getInstance,
  Resources1ysf2j4wd5yk7 as Resources,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_8,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
  Mixin3lmkm5hum2vdj as Mixin,
  cancel1n0qjc93h2v6w as cancel,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  launchUnscopedAndWait6v8yfjb8olf5 as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance_9,
  Ratio136tf4z2t0p2d as Ratio,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  Ratio__toString_impl_mfgt3e2hpoo0nu4cwhr as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2ienc1iwi3w3dhe1b7 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup5294anfb3s41c1 as Ratio__toFloat_impl_1ftup5,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  get_fast37cu8s8qwnuyi as get_fast,
  FastDuration__times_impl_h6amcp25vm4d6obfh9l as FastDuration__times_impl_h6amcp,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration__plus_impl_q1enab3lvjsvnxno7fk as FastDuration__plus_impl_q1enab,
  FastDuration__div_impl_rlslck1plvf7n5rb7aa as FastDuration__div_impl_rlslck,
  clampdicp8njiht45 as clamp,
  FastDuration__compareTo_impl_4fhnj71anf17lkhs1by as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_nanoseconds__impl__pxizcb3qjtomx85900t as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  FastDuration__minus_impl_evs2371fjveki3j5gyc as FastDuration__minus_impl_evs237,
  _FastDuration___get_fastMilliseconds__impl__pe68va279q35r54j5bc as _FastDuration___get_fastMilliseconds__impl__pe68va,
  clamp1qclpmpfxm7xb as clamp_0,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  FastDuration__compareTo_impl_4fhnj71uadlvoozsr50 as FastDuration__compareTo_impl_4fhnj7_0,
  toRatio1hooqit5gulhr as toRatio,
  FastDuration3d3pupg2e5ora as FastDuration,
  toLongRound7crzegvo2qbo as toLongRound,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  getExtra307y0o9pd6mp3 as getExtra,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Ref2y4j4snnxo6gs as Ref,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_10,
  Scale2cm697xlulcp5 as Scale,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  MMatrix1y71lv7vv6y8t as MMatrix,
  Companion_getInstance3om7tc9mg7edv as Companion_getInstance_11,
  BoundsBuilder__plus_impl_cz7f7x3pz0lxdivao0o as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx3cti8ahdxq1b5 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  invalidOp1stebxh2m3n07 as invalidOp,
  clamp31lhm66c28ic8 as clamp_1,
  toFastList1btvvxvv57pw as toFastList,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  IntDeque2ebok66x2sofm as IntDeque,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g13hz45luccu2o2 as _FastDuration___get_fastMicroseconds__impl__e641g1,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  FastDuration__div_impl_rlslck15f8mt5g6dyds as FastDuration__div_impl_rlslck_0,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x37zmlsrxcrsca as _Frequency___get_hertz__impl__9m7k6x,
  convertRange1a6ancvyn151r as convertRange_0,
  readBitmapSlice1mxfjm5uys58e as readBitmapSlice,
  Bitmaps_instancebct336c8d0m7 as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  Resourceable38whwgli3ts8g as Resourceable,
  slice2pfxfvku0ybgy as slice,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_12,
  Companion_getInstance1ygiwm9bgjia3 as Companion_getInstance_13,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  interpolatewhd2sgxffql5 as interpolate,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  _Angle___get_degrees__impl__qg56vw1zqnfrqkp8did as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv3gpdj6wpeuir3 as _Angle___get_absoluteValue__impl__4qoakv,
  niceStr1ftz2qvn4gdyq as niceStr,
  _RGBA___get_hexString__impl__kocngmzp2nzhttcejz as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqt1opkd4mw5vm2z as _RGBA___get_rgb__impl__tijaqt,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  StandardPaths_instance3ckwvxznkwud8 as StandardPaths_instance,
  Pool1zbsw0zhvh8ca as Pool,
  SizeInte6w85oa6mz6v as SizeInt,
  Signal3nnez3346azzf as Signal,
  Companion_instance21jklwk36y3dn as Companion_instance_4,
  DateTime__minus_impl_10njw81nqbgaa48pgq4 as DateTime__minus_impl_10njw8,
  toFloat3b315y36g90cd as toFloat,
  toRef3av6zm8yavumw as toRef,
  Level_DEBUG_getInstance2cjwrm9110zsz as Level_DEBUG_getInstance,
  FastDuration__toString_impl_c9xohb3cvph1y7s95v4 as FastDuration__toString_impl_c9xohb,
  Ref11k43t82thcp3 as Ref_0,
  toIntp2twe4onfbic as toInt,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  injector13ltfovoybm52 as injector,
  Companion_getInstance9hqru60m2833 as Companion_getInstance_14,
  toIntCeil3h286vm49zgwd as toIntCeil,
} from './korlibs-all.mjs';
import {
  withContext2i47m7ae4v1sd as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScopesisx8kbb9f8x as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel_0,
  Key_instance3o7pj7ik1b183 as Key_instance,
  Job13y4jkazwjho0 as Job,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout3hvfy7xgqgnvm as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
} from './kotlinx-coroutines-core.mjs';
import {
  Companion_getInstance12gtxroo40wno as Companion_getInstance_15,
  DefaultViewport_getInstance3j3s2jy6zu9ca as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2im0li1v0jac6 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1i7uio6gustu7 as KorgeReload_getInstance,
  configureLoggerFromProperties1t3glidkjwd17 as configureLoggerFromProperties,
  CoroutineKey_getInstance3nlh6pc2noqhi as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance1x6f2nb0du729 as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstancegn6n8lkvuoxm as Type_START_getInstance,
  Status_ADD_getInstance2ikhpw2btzfzo as Status_ADD_getInstance,
  Type_END_getInstance331lr99r7xh7i as Type_END_getInstance,
  Status_REMOVE_getInstance21rl9vf9qjrb0 as Status_REMOVE_getInstance,
  Type_MOVE_getInstance2g4jkr289s1a8 as Type_MOVE_getInstance,
  Status_KEEP_getInstance3p1s7ste35m5y as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2dunhocwmk9pi as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance3nknmoqnyfvel as Type_DRAG_getInstance,
  Type_UP_getInstance3cbsyzwl1abw4 as Type_UP_getInstance,
  Type_DOWN_getInstance20slx18g3n9iw as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstance2sn5bsju340al as Companion_getInstance_16,
  Companion_getInstancezx9mtebwpbyq as Companion_getInstance_17,
  Companion_getInstancex1pk9m73g9c6 as Companion_getInstance_18,
  Companion_getInstance35vn8xpzue606 as Companion_getInstance_19,
  Companion_instance2kf6v2is0lhhr as Companion_instance_5,
  Companion_instancelgkpg07onuw2 as Companion_instance_6,
  Companion_instance2ffiktwt5nfeb as Companion_instance_7,
  Companion_instance3nf2h14fw03zr as Companion_instance_8,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance18fciagsd02o3 as Companion_getInstance_20,
  Companion_getInstancenz8ykkb6phk0 as Companion_getInstance_21,
  Companion_instanceozmuwjcmdf52 as Companion_instance_9,
  Companion_instancez9q7819xwnc1 as Companion_instance_10,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instancekrhj1pqvxv6j as Companion_instance_11,
  Type_TYPE_getInstanceae1nnzr8xwbc as Type_TYPE_getInstance,
  Type_DOWN_getInstance313b56cnb7a70 as Type_DOWN_getInstance_0,
  Type_UP_getInstance14prrhxnriw3z as Type_UP_getInstance_0,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  Companion_instance18k7zco3357fp as Companion_instance_12,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance2hvv939x49crx as Companion_getInstance_22,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance24kbqbtea649t as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance3jgth1v8sehkm as Companion_getInstance_23,
  drawText2ld6eqw3mc9xd as drawText,
  Companion_getInstance29r688krv3c4g as Companion_getInstance_24,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont119k9qsj5fsyz as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance3iwen1o4s4mlo as Key_F12_getInstance,
  Key_F7_getInstance1rgyn6mno38yl as Key_F7_getInstance,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
} from './korge-root-korge-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_13 = this;
    this.r6t_1 = Companion_getInstance_0().p1a('Korge');
    this.s6t_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  t6t(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  ed(p1, $completion) {
    return this.t6t(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.g6s_1 = this$0;
    this.h6s_1 = $entry;
  }
  r17($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$withContext, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit) {
    Companion_getInstance_25();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_25().s6t_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_15().v5m_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().l5k_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_26().g3h() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().s20_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().r20_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    unit = unit === VOID ? Unit_instance : unit;
    this.i6s_1 = args;
    this.j6s_1 = imageFormats;
    this.k6s_1 = gameWindow;
    this.l6s_1 = mainSceneClass;
    this.m6s_1 = timeProvider;
    this.n6s_1 = injector;
    this.o6s_1 = configInjector;
    this.p6s_1 = debug;
    this.q6s_1 = trace;
    this.r6s_1 = context;
    this.s6s_1 = fullscreen;
    this.t6s_1 = blocking;
    this.u6s_1 = gameId;
    this.v6s_1 = settingsFolder;
    this.w6s_1 = batchMaxQuads;
    this.x6s_1 = windowSize;
    this.y6s_1 = virtualSize;
    this.z6s_1 = displayMode;
    this.a6t_1 = title;
    this.b6t_1 = backgroundColor;
    this.c6t_1 = quality;
    this.d6t_1 = icon;
    this.e6t_1 = multithreaded;
    this.f6t_1 = forceRenderEveryFrame;
    this.g6t_1 = windowCreationConfig;
    this.h6t_1 = main;
    this.i6t_1 = debugAg;
    this.j6t_1 = debugFontExtraScale;
    this.k6t_1 = debugFontColor;
    this.l6t_1 = stageBuilder;
    this.m6t_1 = targetFps;
    this.n6t_1 = preferSyncIo;
    this.o6t_1 = unit;
  }
  o6w(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu(this, entry, $completion), $completion);
  }
  p6w(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit);
  }
  p6t(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit, $super) {
    args = args === VOID ? this.i6s_1 : args;
    imageFormats = imageFormats === VOID ? this.j6s_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.k6s_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.l6s_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.m6s_1 : timeProvider;
    injector = injector === VOID ? this.n6s_1 : injector;
    configInjector = configInjector === VOID ? this.o6s_1 : configInjector;
    debug = debug === VOID ? this.p6s_1 : debug;
    trace = trace === VOID ? this.q6s_1 : trace;
    context = context === VOID ? this.r6s_1 : context;
    fullscreen = fullscreen === VOID ? this.s6s_1 : fullscreen;
    blocking = blocking === VOID ? this.t6s_1 : blocking;
    gameId = gameId === VOID ? this.u6s_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.v6s_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.w6s_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.x6s_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.y6s_1 : virtualSize;
    displayMode = displayMode === VOID ? this.z6s_1 : displayMode;
    title = title === VOID ? this.a6t_1 : title;
    backgroundColor = backgroundColor === VOID ? this.b6t_1 : backgroundColor;
    quality = quality === VOID ? this.c6t_1 : quality;
    icon = icon === VOID ? this.d6t_1 : icon;
    multithreaded = multithreaded === VOID ? this.e6t_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.f6t_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.g6t_1 : windowCreationConfig;
    main = main === VOID ? this.h6t_1 : main;
    debugAg = debugAg === VOID ? this.i6t_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.j6t_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.k6t_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.l6t_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.m6t_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.n6t_1 : preferSyncIo;
    unit = unit === VOID ? this.o6t_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.p6w(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit);
    } else {
      var tmp_0 = $super.p6w;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.i6s_1);
    var tmp_0 = this.j6s_1.toString();
    var tmp_1 = toString_0(this.k6s_1);
    var tmp_2 = toString_0(this.l6s_1);
    var tmp_3 = toString(this.m6s_1);
    var tmp_4 = this.n6s_1.toString();
    var tmp_5 = toString(this.o6s_1);
    var tmp_6 = toString_0(this.r6s_1);
    var tmp_7 = this.x6s_1.toString();
    var tmp_8 = this.y6s_1.toString();
    var tmp_9 = this.z6s_1.toString();
    var tmp_10 = this.b6t_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.p6s_1 + ', trace=' + this.q6s_1 + ', context=' + tmp_6 + ', fullscreen=' + this.s6s_1 + ', blocking=' + this.t6s_1 + ', gameId=' + this.u6s_1 + ', settingsFolder=' + this.v6s_1 + ', batchMaxQuads=' + this.w6s_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.a6t_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.c6t_1) + ', icon=' + this.d6t_1 + ', multithreaded=' + this.e6t_1 + ', forceRenderEveryFrame=' + this.f6t_1 + ', windowCreationConfig=' + this.g6t_1.toString() + ', main=' + toString(this.h6t_1) + ', debugAg=' + this.i6t_1 + ', debugFontExtraScale=' + this.j6t_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.k6t_1) + ', stageBuilder=' + toString(this.l6t_1) + ', targetFps=' + this.m6t_1 + ', preferSyncIo=' + this.n6t_1 + ', unit=' + this.o6t_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.i6s_1);
    result = imul(result, 31) + hashCode(this.j6s_1) | 0;
    result = imul(result, 31) + (this.k6s_1 == null ? 0 : hashCode(this.k6s_1)) | 0;
    result = imul(result, 31) + (this.l6s_1 == null ? 0 : this.l6s_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.m6s_1) | 0;
    result = imul(result, 31) + hashCode(this.n6s_1) | 0;
    result = imul(result, 31) + hashCode(this.o6s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p6s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6s_1) | 0;
    result = imul(result, 31) + (this.r6s_1 == null ? 0 : hashCode(this.r6s_1)) | 0;
    result = imul(result, 31) + (this.s6s_1 == null ? 0 : getBooleanHashCode(this.s6s_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u6s_1) | 0;
    result = imul(result, 31) + (this.v6s_1 == null ? 0 : getStringHashCode(this.v6s_1)) | 0;
    result = imul(result, 31) + this.w6s_1 | 0;
    result = imul(result, 31) + this.x6s_1.hashCode() | 0;
    result = imul(result, 31) + this.y6s_1.hashCode() | 0;
    result = imul(result, 31) + this.z6s_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.a6t_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.b6t_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.b6t_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.c6t_1.hashCode() | 0;
    result = imul(result, 31) + (this.d6t_1 == null ? 0 : getStringHashCode(this.d6t_1)) | 0;
    result = imul(result, 31) + (this.e6t_1 == null ? 0 : getBooleanHashCode(this.e6t_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6t_1) | 0;
    result = imul(result, 31) + this.g6t_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.h6t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i6t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j6t_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.k6t_1) | 0;
    result = imul(result, 31) + hashCode(this.l6t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m6t_1) | 0;
    result = imul(result, 31) + (this.n6t_1 == null ? 0 : getBooleanHashCode(this.n6t_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.i6s_1, tmp0_other_with_cast.i6s_1))
      return false;
    if (!equals(this.j6s_1, tmp0_other_with_cast.j6s_1))
      return false;
    if (!equals(this.k6s_1, tmp0_other_with_cast.k6s_1))
      return false;
    if (!equals(this.l6s_1, tmp0_other_with_cast.l6s_1))
      return false;
    if (!equals(this.m6s_1, tmp0_other_with_cast.m6s_1))
      return false;
    if (!equals(this.n6s_1, tmp0_other_with_cast.n6s_1))
      return false;
    if (!equals(this.o6s_1, tmp0_other_with_cast.o6s_1))
      return false;
    if (!(this.p6s_1 === tmp0_other_with_cast.p6s_1))
      return false;
    if (!(this.q6s_1 === tmp0_other_with_cast.q6s_1))
      return false;
    if (!equals(this.r6s_1, tmp0_other_with_cast.r6s_1))
      return false;
    if (!(this.s6s_1 == tmp0_other_with_cast.s6s_1))
      return false;
    if (!(this.t6s_1 === tmp0_other_with_cast.t6s_1))
      return false;
    if (!(this.u6s_1 === tmp0_other_with_cast.u6s_1))
      return false;
    if (!(this.v6s_1 == tmp0_other_with_cast.v6s_1))
      return false;
    if (!(this.w6s_1 === tmp0_other_with_cast.w6s_1))
      return false;
    if (!this.x6s_1.equals(tmp0_other_with_cast.x6s_1))
      return false;
    if (!this.y6s_1.equals(tmp0_other_with_cast.y6s_1))
      return false;
    if (!this.z6s_1.equals(tmp0_other_with_cast.z6s_1))
      return false;
    if (!(this.a6t_1 === tmp0_other_with_cast.a6t_1))
      return false;
    var tmp = this.b6t_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.b6t_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.c6t_1.equals(tmp0_other_with_cast.c6t_1))
      return false;
    if (!(this.d6t_1 == tmp0_other_with_cast.d6t_1))
      return false;
    if (!(this.e6t_1 == tmp0_other_with_cast.e6t_1))
      return false;
    if (!(this.f6t_1 === tmp0_other_with_cast.f6t_1))
      return false;
    if (!this.g6t_1.equals(tmp0_other_with_cast.g6t_1))
      return false;
    if (!equals(this.h6t_1, tmp0_other_with_cast.h6t_1))
      return false;
    if (!(this.i6t_1 === tmp0_other_with_cast.i6t_1))
      return false;
    if (!equals(this.j6t_1, tmp0_other_with_cast.j6t_1))
      return false;
    if (!(this.k6t_1 === tmp0_other_with_cast.k6t_1))
      return false;
    if (!equals(this.l6t_1, tmp0_other_with_cast.l6t_1))
      return false;
    if (!equals(this.m6t_1, tmp0_other_with_cast.m6t_1))
      return false;
    if (!(this.n6t_1 == tmp0_other_with_cast.n6t_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_14 = this;
    this.k6w_1 = new KorgeDisplayMode(Companion_getInstance_2().w3c_1, Companion_getInstance_3().z35(), true);
    this.l6w_1 = new KorgeDisplayMode(Companion_getInstance_2().w3c_1, Companion_getInstance_3().z35(), false);
    this.m6w_1 = new KorgeDisplayMode(Companion_getInstance_2().w3c_1, Companion_getInstance_3().n35_1, false);
    this.n6w_1 = new KorgeDisplayMode(Companion_getInstance_2().y3c_1, Companion_getInstance_3().n35_1, false);
  }
  g3h() {
    return this.k6w_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_26();
    this.q6w_1 = scaleMode;
    this.r6w_1 = scaleAnchor;
    this.s6w_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.q6w_1.toString() + ', scaleAnchor=' + this.r6w_1.toString() + ', clipBorders=' + this.s6w_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.q6w_1);
    result = imul(result, 31) + this.r6w_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.q6w_1, tmp0_other_with_cast.q6w_1))
      return false;
    if (!this.r6w_1.equals(tmp0_other_with_cast.r6w_1))
      return false;
    if (!(this.s6w_1 === tmp0_other_with_cast.s6w_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.h6z_1 = $config;
    this.i6z_1 = $views;
    this.j6z_1 = $entry;
    this.k6z_1 = $gameWindow;
  }
  r17($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $this$coroutineScope, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.n74_1 = $config;
    this.o74_1 = $views;
    this.p74_1 = $entry;
    this.q74_1 = $gameWindow;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1(this, $completion), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.r74_1 = $realGameWindow;
    this.s74_1 = $windowSize;
    this.t74_1 = $config;
    this.u74_1 = $iconPath;
    this.v74_1 = $imageFormats;
    this.w74_1 = $entry;
  }
  e75($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2(this, $this$loop, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.e75(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.f75_1 = $views;
  }
  dd($completion) {
    this.f75_1.p5();
  }
}
class KorgeRunner {
  q6t(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3(this, config, $completion), $completion);
  }
  a75(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.a6x_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.w2l(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.z6w_1;
    injector.w2l(getKClass(AG), instance);
    injector.w2l(getKClass(Resources), views.h75());
    var tmp = getKClass(ResourcesRoot);
    injector.z2l(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.b6x_1;
    injector.w2l(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.d6x_1;
    injector.w2l(getKClass(Stats), instance_1);
    injector.w2l(getKClass(CoroutineContext), views.y6w_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.a2m(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.w2l(getKClass(TimeProvider), views.c6x_1);
    configInjector(injector);
    var input = views.b6x_1;
    var ag = views.z6w_1;
    var downPos = {_v: Companion_getInstance_8().r36_1};
    var upPos = {_v: Companion_getInstance_8().r36_1};
    var downTime = {_v: new DateTime(Companion_getInstance_7().o2s_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_7().o2s_1)};
    var upTime = Companion_getInstance_7().o2s_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.i75(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_16().t3s_1.slice();
    eventDispatcher.d3r(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_17().f3s_1.slice();
    eventDispatcher.d3r(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_18().s3t_1.slice();
    eventDispatcher.d3r(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_19().z3t_1.slice();
    eventDispatcher.d3r(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_5;
    eventDispatcher.r3q(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_6;
    eventDispatcher.r3q(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_7;
    eventDispatcher.r3q(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_8;
    eventDispatcher.r3q(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_20().q3u_1.slice();
    eventDispatcher.d3r(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_21().v3w_1.slice();
    eventDispatcher.d3r(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_9;
    eventDispatcher.r3q(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_10;
    eventDispatcher.r3q(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.c3r(new ReshapeEvent(0, 0, views.j75(), views.k75()));
    var tmp_13 = Companion_instance_11;
    eventDispatcher.r3q(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.y6x_1 = clearEachFrame;
    views.z6x_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.e6x_1.s5w(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  t6t(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  ed(p1, $completion) {
    return this.t6t(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  t6t(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  ed(p1, $completion) {
    return this.t6t(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.r75_1 = this$0;
    this.s75_1 = $event;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4(this, $completion), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.t75_1 = this$0;
    this.u75_1 = $event;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5(this, $completion), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.v75_1 = this$0;
    this.w75_1 = $event;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6(this, $completion), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.l75_1 = view;
    this.n75_1 = new AsyncSignal();
    this.o75_1 = new AsyncSignal();
    this.p75_1 = new AsyncSignal();
    this.q75_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.l75_1.r3q(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.l75_1.r3q(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.l75_1.r3q(tmp_1, KeysEvents$lambda_1(this));
  }
  x75() {
    var tmp = this.m75_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  p5() {
    this.q75_1.p5();
  }
}
class Scene {
  constructor() {
    this.y75_1 = new Mixin();
    this.d76_1 = Container.w78();
    this.e76_1 = new CancellableGroup();
    var tmp = this;
    tmp.f76_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.g76_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.h76_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  b1i(_set____db54di) {
    this.y75_1.b1i(_set____db54di);
  }
  c1i() {
    return this.y75_1.c1i();
  }
  k76() {
    var tmp = this.z75_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  x78(_set____db54di) {
    this.a76_1 = _set____db54di;
  }
  j76() {
    var tmp = this.a76_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  l76() {
    var tmp = this.b76_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  qo() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f76_1;
    coroutineContext$factory();
    return this_0.h3();
  }
  y78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g76_1;
    sceneView$factory();
    return this_0.h3();
  }
  m76(size) {
    return SContainer.k7b(size);
  }
  h2m(injector) {
    this.z75_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.f2m(getKClass(Views));
    this.x78(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.b76_1 = injector.f2m(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.c76_1 = injector.f2m(getKClass(ResourcesRoot));
  }
  l7b(_this__u8e3s4, $completion) {
  }
  m7b(_this__u8e3s4, $completion) {
  }
  n7b($completion) {
  }
  o7b($completion) {
  }
  p7b($completion) {
  }
  q7b($completion) {
    cancel(this.e76_1);
    this.k76().i2m();
  }
  i76($completion) {
  }
  r7b($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219(this, $completion), $completion);
  }
}
class EmptyScene extends Scene {
  m7b(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.j7f_1 = clazz;
    this.k7f_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.j7f_1) + ', injects=' + toString(this.k7f_1) + ')';
  }
  hashCode() {
    var result = this.j7f_1.hashCode();
    result = imul(result, 31) + hashCode(this.k7f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.j7f_1.equals(tmp0_other_with_cast.j7f_1))
      return false;
    if (!equals(this.k7f_1, tmp0_other_with_cast.k7f_1))
      return false;
    return true;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_15 = this;
    this.m7c_1 = Companion_getInstance_0().p1a('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.n7c_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.c7c_1 = this$0;
    this.d7c_1 = $event;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.q7c_1 = $newScene;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.r7c_1 = $newScene;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.s7c_1 = $oldScene;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.t7c_1 = $oldScene;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.u7c_1 = $oldScene;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12(this, $completion), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.v7c_1 = $newScene;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13(this, $completion), $completion);
  }
}
class BaseView extends BaseEventListener {
  static s7s() {
    return this.p3q();
  }
  e7l() {
  }
}
class View extends BaseView {
  static n7v(isContainer) {
    var $this = this.s7s();
    $this.p6z_1 = isContainer;
    var tmp = $this;
    tmp.q6z_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.r6z_1 = true;
    $this.s6z_1 = null;
    $this.t6z_1 = null;
    $this.u6z_1 = null;
    $this.v6z_1 = 0;
    $this.w6z_1 = null;
    $this.x6z_1 = 1.0;
    $this.y6z_1 = null;
    $this.z6z_1 = null;
    $this.a70_1 = null;
    $this.b70_1 = Companion_getInstance_23().z5e_1;
    $this.c70_1 = 0.0;
    $this.d70_1 = 0.0;
    $this.e70_1 = 1.0;
    $this.f70_1 = 1.0;
    $this.g70_1 = Companion_getInstance_13().d36_1;
    $this.h70_1 = Companion_getInstance_13().d36_1;
    $this.i70_1 = Companion_getInstance_13().d36_1;
    $this.j70_1 = 0.0;
    $this.k70_1 = scale$factory($this);
    $this.l70_1 = false;
    $this.m70_1 = true;
    $this.n70_1 = true;
    $this.o70_1 = true;
    $this.p70_1 = true;
    $this.q70_1 = Companion_getInstance_12().v37_1;
    $this.r70_1 = Companion_getInstance_12().v37_1;
    $this.s70_1 = -1;
    $this.t70_1 = Companion_getInstance_12().v37_1;
    $this.u70_1 = -1;
    $this.v70_1 = new ColorTransformMul();
    $this.w70_1 = new ColorTransformMul();
    $this.x70_1 = -1;
    $this.y70_1 = Companion_getInstance_23().z5e_1;
    $this.z70_1 = -1;
    $this.a71_1 = true;
    $this.b71_1 = 0;
    $this.c71_1 = 0;
    $this.d71_1 = false;
    $this.e71_1 = false;
    $this.f71_1 = null;
    $this.g71_1 = false;
    $this.h71_1 = null;
    $this.i71_1 = 0;
    $this.j71_1 = true;
    $this.k71_1 = null;
    return $this;
  }
  static w7x() {
    return this.n7v(false);
  }
  y7l() {
    return 0.0;
  }
  z7l() {
    return 0.0;
  }
  h7l() {
    return null;
  }
  e86(_set____db54di) {
    this.t6z_1 = _set____db54di;
  }
  a7m(value) {
    this.v6z_1 = value;
  }
  g3x() {
    return this.v6z_1;
  }
  b7m(value) {
    if (this.y6z_1 === value)
      return Unit_instance;
    this.y6z_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp337_safe_receiver = this.h7l();
    var tmp;
    if (tmp337_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp337_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp337_safe_receiver.f1(_unary__edvuaz).b7m(value);
      }
      tmp = Unit_instance;
    }
    this.c7m();
  }
  c7m() {
  }
  d7m(value) {
    if (this.z6z_1 === value)
      return Unit_instance;
    this.z6z_1 = value;
    var parent = this.f7l();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp337_safe_receiver = this.h7l();
    var tmp;
    if (tmp337_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp337_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp337_safe_receiver.f1(_unary__edvuaz).d7m(parent);
      }
      tmp = Unit_instance;
    }
  }
  f7l() {
    return this.z6z_1;
  }
  e7m() {
    var tmp345_safe_receiver = this.w6z_1;
    this.d7m(tmp345_safe_receiver == null ? null : tmp345_safe_receiver.f7l());
  }
  f7m(value) {
    if (this.w6z_1 === value)
      return Unit_instance;
    this.w6z_1 = value;
    var tmp346_safe_receiver = this.w6z_1;
    this.b7m(tmp346_safe_receiver == null ? null : tmp346_safe_receiver.y6z_1);
    this.e7m();
    this.j7n();
    this.q3q(value);
  }
  f1r() {
    return this.w6z_1;
  }
  g7m(x, y) {
    this.y7m();
    if (!(this.c70_1 === x) || !(this.d70_1 === y)) {
      this.c70_1 = x;
      this.d70_1 = y;
      this.h7n();
    }
  }
  n3u() {
    this.y7m();
    return this.c70_1;
  }
  o3u() {
    this.y7m();
    return this.d70_1;
  }
  h7m() {
    return this.j70_1;
  }
  i7m(v) {
    this.o7m(Scale.j3b(v, v));
  }
  j7m() {
    return this.p7m().n3c();
  }
  k7m(v) {
    this.y7m();
    if (!(this.e70_1 === v)) {
      this.e70_1 = v;
      this.h7n();
    }
  }
  l7m() {
    this.y7m();
    return this.e70_1;
  }
  m7m(v) {
    this.y7m();
    if (!(this.f70_1 === v)) {
      this.f70_1 = v;
      this.h7n();
    }
  }
  n7m() {
    this.y7m();
    return this.f70_1;
  }
  o7m(value) {
    this.k7m(value.h3b_1);
    this.m7m(value.i3b_1);
  }
  p7m() {
    return Scale.j3b(this.l7m(), this.n7m());
  }
  q7m() {
    this.y7m();
    return this.g70_1;
  }
  r7m() {
    this.y7m();
    return this.h70_1;
  }
  f86(v) {
    this.y7m();
    if (!equals(this.i70_1, v)) {
      this.i70_1 = v;
      this.h7n();
    }
  }
  s7m() {
    this.y7m();
    return this.i70_1;
  }
  t7m() {
    var tmp348_safe_receiver = this.f1r();
    var tmp0_elvis_lhs = tmp348_safe_receiver == null ? null : tmp348_safe_receiver.p7n(Vector2D.h38(this.n3u(), this.o3u()));
    return tmp0_elvis_lhs == null ? Vector2D.h38(this.n3u(), this.o3u()) : tmp0_elvis_lhs;
  }
  d1() {
    return this.j7i();
  }
  j7i() {
    return this.e7o().d1();
  }
  u7m() {
    return this.j7i().c37_1;
  }
  v7m() {
    return this.j7i().d37_1;
  }
  h1j() {
    return this.u7m();
  }
  i1j() {
    return this.v7m();
  }
  a29() {
    return this.v70_1.a29();
  }
  w7m(v) {
    if (!(this.v70_1.z28() === v)) {
      this.v70_1.y28(v);
      this.j7l();
    }
  }
  x7m() {
    return this.v70_1.z28();
  }
  y7m() {
    if (this.o70_1)
      return Unit_instance;
    this.o70_1 = true;
    var t = this.q70_1.y38();
    this.c70_1 = t.c39_1;
    this.d70_1 = t.d39_1;
    this.e70_1 = t.e39_1;
    this.f70_1 = t.f39_1;
    this.g70_1 = t.g39_1;
    this.h70_1 = t.h39_1;
    this.i70_1 = t.i39_1;
  }
  i2s() {
    var tmp350_safe_receiver = this.f1r();
    var tmp0_elvis_lhs = tmp350_safe_receiver == null ? null : tmp350_safe_receiver.i2s();
    return tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
  }
  z7m() {
    return this.y6z_1;
  }
  a7n() {
    return this.n70_1;
  }
  b7n() {
    if (!this.p70_1) {
      this.p70_1 = true;
      this.d71_1 = true;
      this.q70_1 = Companion_getInstance_12().f38(this.n3u(), this.o3u(), this.s7m(), this.l7m(), this.n7m(), this.q7m(), this.r7m(), 0.0, 0.0);
    }
    return this.q70_1;
  }
  c7n() {
    if (!(this.s70_1 === this.b71_1)) {
      this.s70_1 = this.b71_1;
      this.d71_1 = true;
      this.r70_1 = !(this.f1r() == null) ? this.b7n().i38(ensureNotNull(this.f1r()).c7n()) : this.b7n();
    }
    return this.r70_1;
  }
  d7n() {
    if (!(this.u70_1 === this.b71_1)) {
      this.u70_1 = this.b71_1;
      this.d71_1 = true;
      this.t70_1 = this.c7n().x38();
    }
    return this.t70_1;
  }
  e7n() {
    updateRenderColorTransformIfRequired(this);
    return this.w70_1;
  }
  f7n() {
    updateRenderBlendModeIfRequired(this);
    return this.y70_1;
  }
  g7n() {
    updateRenderColorTransformIfRequired(this);
    return this.w70_1.a29();
  }
  h7n() {
    this.p70_1 = false;
    this.i7l();
  }
  i7l() {
    this.b71_1 = this.b71_1 + 1 | 0;
    this.d71_1 = false;
    this.a71_1 = true;
    this.e7l();
  }
  i7n() {
    if (!(this.f71_1 == null)) {
      this.f71_1 = null;
      var tmp354_safe_receiver = this.f1r();
      if (tmp354_safe_receiver == null)
        null;
      else {
        tmp354_safe_receiver.i7n();
      }
    }
  }
  j7n() {
    this.m7i();
  }
  k7n() {
    this.m7i();
  }
  m7i() {
  }
  e7l() {
    var tmp355_safe_receiver = this.z6z_1;
    if (tmp355_safe_receiver == null)
      null;
    else {
      tmp355_safe_receiver.g7l(this);
    }
    this.i7n();
  }
  j7l() {
    this.c71_1 = this.c71_1 + 1 | 0;
    this.e71_1 = false;
    this.a71_1 = true;
    this.e7l();
  }
  k7i(ctx) {
    if (!this.a7n())
      return Unit_instance;
    var tmp361_safe_receiver = this.h71_1;
    if (tmp361_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp361_safe_receiver.i1h_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].m86(this, ctx);
      }
    }
    try {
      this.l7n(ctx);
    }finally {
      var tmp362_safe_receiver = this.h71_1;
      if (tmp362_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp362_safe_receiver.i1h_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp362_safe_receiver.d1() - n_0 | 0) - 1 | 0].n86(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  l7n(ctx) {
    var oldPhase = this.i71_1;
    try {
      this.i71_1 = 0;
      this.m7n(ctx);
    }finally {
      this.i71_1 = oldPhase;
    }
  }
  m7n(ctx) {
    var stages = this.h71_1;
    if (!(stages == null) && this.i71_1 < stages.d1()) {
      var _unary__edvuaz = this.i71_1;
      this.i71_1 = _unary__edvuaz + 1 | 0;
      stages.f1(_unary__edvuaz).o86(this, ctx);
    } else {
      var tmp = this.i71_1;
      var tmp0_elvis_lhs = stages == null ? null : stages.d1();
      if (equals(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs)) {
        this.o7i(ctx);
        this.i71_1 = this.i71_1 + 1 | 0;
      }
    }
  }
  r7l(ctx) {
    if (this.g71_1 || this === get_debugAnnotateView(ctx)) {
      this.n7n(ctx);
    }
  }
  n7n(ctx) {
    var local = this.e7o();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.m5p_1;
    if (!(this_1.v5g_1 === this_0)) {
      this_1.v5g_1 = this_0;
      this_1.f5i();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.y5p_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_23().i5f_1;
          var doUpdate = !(this_0.x5p_1 === blending);
          var old = this_0.x5p_1;
          try {
            if (doUpdate) {
              this_0.m5p_1.f5i();
              this_0.x5p_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().t20_1;
            var m = this_0.y5p_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.p5p_1;
            this_0.p5p_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.q3g(this.x7n());
              this_0.e5q(this_3, m);
            }finally {
              this_0.p5p_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.m5p_1.f5i();
            }
            this_0.x5p_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().t20_1;
        var m_0 = this_0.y5p_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.p5p_1;
        this_0.p5p_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.a3e(this.p7n(Vector2D.h38(local.o1x(), local.p1x())));
          this_4.o3g(this.p7n(Vector2D.h38(local.q1x(), local.p1x())));
          this_4.o3g(this.p7n(Vector2D.h38(local.q1x(), local.r1x())));
          this_4.o3g(this.p7n(Vector2D.h38(local.o1x(), local.r1x())));
          this_4.p5();
          this_0.e5q(this_4, m_0);
        }finally {
          this_0.p5p_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().h26_1;
        var m_1 = this_0.y5p_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.p5p_1;
        this_0.p5p_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).g5p();
          this_5.u3g(this.p7n(local.h37()), anchorSize);
          this_5.u3g(this.p7n(local.u3b()), anchorSize);
          this_5.u3g(this.p7n(local.j37()), anchorSize);
          this_5.u3g(this.p7n(local.v3b()), anchorSize);
          this_5.u3g(this.p7n(interpolate(Companion_getInstance_9().j35_1, local.h37(), local.u3b())), anchorSize);
          this_5.u3g(this.p7n(interpolate(Companion_getInstance_9().j35_1, local.u3b(), local.j37())), anchorSize);
          this_5.u3g(this.p7n(interpolate(Companion_getInstance_9().j35_1, local.j37(), local.v3b())), anchorSize);
          this_5.u3g(this.p7n(interpolate(Companion_getInstance_9().j35_1, local.v3b(), local.h37())), anchorSize);
          this_0.e5q(this_5, m_1);
        }finally {
          this_0.p5p_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().v20_1;
        var m_2 = this_0.y5p_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.p5p_1;
        this_0.p5p_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.t7m();
          this_6.p3g(Vector2D.h38(center.l36_1, center.m36_1 - 5), Vector2D.h38(center.l36_1, center.m36_1 + 5));
          this_6.p3g(Vector2D.h38(center.l36_1 - 5, center.m36_1), Vector2D.h38(center.l36_1 + 5, center.m36_1));
          this_0.e5q(this_6, m_2);
        }finally {
          this_0.p5p_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.n3u() === 0.0) || !(this.o3u() === 0.0))
      out = out + (':pos=(' + this.o7n(this.n3u()) + ',' + this.o7n(this.o3u()) + ')');
    if (!(this.l7m() === 1.0) || !(this.n7m() === 1.0))
      out = out + (':scale=(' + this.o7n(this.l7m()) + ',' + this.o7n(this.n7m()) + ')');
    if (!equals(this.q7m(), Companion_getInstance_13().d36_1) || !equals(this.r7m(), Companion_getInstance_13().d36_1))
      out = out + (':skew=(' + this.o7n(_Angle___get_degrees__impl__qg56vw(this.q7m())) + ',' + this.o7n(_Angle___get_degrees__impl__qg56vw(this.r7m())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.s7m()), Companion_getInstance_13().d36_1))
      out = out + (':rotation=(' + this.o7n(_Angle___get_degrees__impl__qg56vw(this.s7m())) + '\xBA)');
    if (!(this.a70_1 == null))
      out = out + (':name=(' + this.a70_1 + ')');
    if (!this.b70_1.equals(Companion_getInstance_23().z5e_1))
      out = out + (':blendMode=(' + this.b70_1.toString() + ')');
    if (!this.a7n())
      out = out + (':visible=' + this.a7n());
    if (!(this.x7m() === 1.0))
      out = out + (':alpha=' + niceStr(this.x7m(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.a29()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().r20_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.a29()));
    return out;
  }
  o7n(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  p7n(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.c7n();
      if (this_0.g37()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.h38(this_0.m38(p.l36_1, p.m36_1), this_0.o38(p.l36_1, p.m36_1));
    }
    return tmp$ret$0;
  }
  q7n() {
    var tmp375_safe_receiver = this.f1r();
    if (tmp375_safe_receiver == null)
      null;
    else
      tmp375_safe_receiver.x7l(this);
  }
  r7n(target, inclusive) {
    var tmp;
    if (target === this.f1r()) {
      tmp = this.b7n();
    } else if (target === this) {
      tmp = Companion_getInstance_12().v37_1;
    } else {
      var commonAncestor = Companion_instance_18.l86(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.f1r() == null && inclusive) {
          return this.c7n();
        }
        tmp_0 = this.c7n().i38(target.d7n());
      } else {
        tmp_0 = Companion_getInstance_12().v37_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.i38(target.b7n());
    }
    return out;
  }
  s7n() {
    var tmp0_elvis_lhs = this.t7n();
    return tmp0_elvis_lhs == null ? this.z7n() : tmp0_elvis_lhs;
  }
  t7n() {
    var stage = this.i2s();
    if (!(stage instanceof Stage))
      return null;
    return this.u7n(stage);
  }
  u7n(bp) {
    return this.z7n().b3c(bp.d5p());
  }
  v7n(ctx) {
    return ctx.p5q() ? this.u7n(ctx) : this.z7n();
  }
  w7n(ctx) {
    return this.v7n(ctx);
  }
  x7n() {
    return this.z7n();
  }
  y7n(includeFilters) {
    return this.c7o(this.i2s(), VOID, true, includeFilters);
  }
  z7n(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.y7n(includeFilters) : $super.y7n.call(this, includeFilters);
  }
  a7o(concat, doAnchoring, includeFilters) {
    var out = this.d7o(doAnchoring, includeFilters);
    if (concat.j38() && !concat.k38()) {
      var tmp = Companion_getInstance_11();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.h37();
        if (concat.g37()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.h38(concat.m38(p.l36_1, p.m36_1), concat.o38(p.l36_1, p.m36_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.u3b();
        if (concat.g37()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.h38(concat.m38(p_0.l36_1, p_0.m36_1), concat.o38(p_0.l36_1, p_0.m36_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.j37();
        if (concat.g37()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.h38(concat.m38(p_1.l36_1, p_1.m36_1), concat.o38(p_1.l36_1, p_1.m36_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.v3b();
        if (concat.g37()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.h38(concat.m38(p_2.l36_1, p_2.m36_1), concat.o38(p_2.l36_1, p_2.m36_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.q36(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  b7o(target, doAnchoring, inclusive, includeFilters) {
    return this.a7o(this.r7n(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  c7o(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.b7o(target, doAnchoring, inclusive, includeFilters) : $super.b7o.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  d7o(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.f71_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.l7i();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.f71_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.t38(Vector2D.o3b(this.y7l(), this.z7l()));
    }
    if (includeFilters) {
      var tmp376_safe_receiver = get_filter(this);
      if (tmp376_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp376_safe_receiver, out);
      }
    }
    return out;
  }
  e7o(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.d7o(doAnchoring, includeFilters) : $super.d7o.call(this, doAnchoring, includeFilters);
  }
  l7i() {
    return Companion_getInstance_10().o36();
  }
  y3q(type, event, result) {
    var tmp379_safe_receiver = this.f1r();
    if (tmp379_safe_receiver == null)
      null;
    else
      tmp379_safe_receiver.f3r(type, event, result);
  }
}
class Container extends View {
  static w78(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.n7v(true);
    $this.n78_1 = cull;
    $this.o78_1 = FastArrayList.j1h();
    $this.p78_1 = new ContainerCollection($this, $this.o78_1);
    $this.q78_1 = null;
    $this.r78_1 = new MMatrix();
    $this.s78_1 = false;
    $this.t78_1 = false;
    $this.u78_1 = FastArrayList.j1h();
    return $this;
  }
  h7l() {
    return this.o78_1;
  }
  i7l() {
    super.i7l();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.p78_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      if (child.d71_1) {
        child.i7l();
      }
    }
  }
  j7l() {
    super.j7l();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.p78_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      if (child.e71_1) {
        child.j7l();
      }
    }
  }
  k7l() {
    return this.o78_1.d1();
  }
  l7l(view) {
  }
  m7i() {
    super.m7i();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp337_safe_receiver = this.h7l();
    var tmp;
    if (tmp337_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp337_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp337_safe_receiver.f1(_unary__edvuaz).k7n();
      }
      tmp = Unit_instance;
    }
  }
  m7l(index) {
    return this.o78_1.f1(index);
  }
  n7l(index) {
    return getOrNull(this.o78_1, index);
  }
  o7l(index) {
    return this.x7l(this.n7l(index));
  }
  k7o() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.p78_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      child.f7m(null);
      child.a7m(-1);
    }
    this.o78_1.z2();
    this.t7l();
  }
  p7l(view) {
    return this.w7l(view, this.k7l());
  }
  v78(view) {
    this.w7l(view, this.k7l());
  }
  f1(index) {
    return this.m7l(index);
  }
  o7i(ctx) {
    if (!this.a7n())
      return Unit_instance;
    this.q7l(ctx);
  }
  q7l(ctx) {
    if (!this.n78_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.s78_1) {
        this.s78_1 = true;
        this.u78_1.z2();
        this.u78_1.e1(this.p78_1);
        if (this.s7l())
          this.t78_1 = false;
      }
      if (!this.t78_1) {
        this.t78_1 = true;
        sortWith(this.u78_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.u78_1.i1h_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].k7i(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp0_elvis_lhs = clippingContainer == null ? null : clippingContainer.z7n();
    var bounds = tmp0_elvis_lhs == null ? Companion_getInstance_10().o36() : tmp0_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.s78_1) {
      this.s78_1 = true;
      this.u78_1.z2();
      this.u78_1.e1(this.p78_1);
      if (this.s7l())
        this.t78_1 = false;
    }
    if (!this.t78_1) {
      this.t78_1 = true;
      sortWith(this.u78_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.u78_1.i1h_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.g37() || bounds.w3b(child.y7n(true))) {
        child.k7i(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  r7l(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.s78_1) {
      this.s78_1 = true;
      this.u78_1.z2();
      this.u78_1.e1(this.p78_1);
      if (this.s7l())
        this.t78_1 = false;
    }
    if (!this.t78_1) {
      this.t78_1 = true;
      sortWith(this.u78_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.u78_1.i1h_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].r7l(ctx);
    }
    super.r7l(ctx);
  }
  l7i() {
    var bb = Companion_getInstance_11().p36();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.p78_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.c7o(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  s7l() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.o78_1.i1h_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].h7m() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  t7l() {
    this.s78_1 = false;
    this.u7l();
  }
  u7l() {
    var tmp227_safe_receiver = this.z7m();
    var tmp228_safe_receiver = tmp227_safe_receiver == null ? null : tmp227_safe_receiver.j76();
    if (tmp228_safe_receiver == null)
      null;
    else {
      tmp228_safe_receiver.g7l(this);
    }
  }
  v7l(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  w7l(view, index) {
    this.v7l(view);
    var tmp229_safe_receiver = view.f1r();
    if (tmp229_safe_receiver == null)
      null;
    else {
      tmp229_safe_receiver.t7l();
    }
    view.q7n();
    var aindex = clamp_1(index, 0, this.k7l());
    view.a7m(aindex);
    var children = this.o78_1;
    children.k6(aindex, view);
    var inductionVariable = aindex + 1 | 0;
    var last = children.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.f1(n).a7m(n);
      }
       while (inductionVariable < last);
    view.f7m(this);
    view.i7l();
    this.l7l(view);
    this.t7l();
    this.u7l();
    this.i7n();
  }
  x7l(view) {
    if (!((view == null ? null : view.f1r()) === this))
      return false;
    var inductionVariable = view.g3x() + 1 | 0;
    var last = this.k7l();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _receiver__tnumb7 = this.o78_1.f1(i);
        var _unary__edvuaz = _receiver__tnumb7.g3x();
        _receiver__tnumb7.a7m(_unary__edvuaz - 1 | 0);
      }
       while (inductionVariable < last);
    this.o78_1.w2(view.g3x());
    view.f7m(null);
    view.a7m(-1);
    this.t7l();
    this.u7l();
    this.i7n();
    return true;
  }
  v3q(type, event, result) {
    if (this.q78_1 == null)
      this.q78_1 = FastArrayList.q1i(this.p78_1.d1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.o78_1;
    var temp = ensureNotNull(this.q78_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.i1h_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].e3r(type, event, result);
      }
    }finally {
      temp.z2();
    }
  }
}
class CachedContainer extends Container {
  static t7s(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.w78();
    $this.x7k_1 = cache;
    $this.y7k_1 = renderQuality;
    $this.z7k_1 = null;
    $this.a7l_1 = true;
    $this.b7l_1 = -1.0;
    $this.c7l_1 = Companion_getInstance_10().v2a();
    $this.d7l_1 = Scale.q3c(1);
    return $this;
  }
  e7l() {
    super.e7l();
    this.a7l_1 = true;
  }
  o7i(ctx) {
    if (!this.a7n())
      return Unit_instance;
    if (!this.x7k_1) {
      return super.o7i(ctx);
    }
    if (this.z7k_1 == null) {
      this.z7k_1 = new CacheTexture(this, ctx);
      this.a7l_1 = true;
    }
    var cache = ensureNotNull(this.z7k_1);
    ctx.t5q(cache);
    var renderScale = ctx.k5q().j3_1 === 0 ? 1.0 : ctx.g5q();
    var tmp0_elvis_lhs = this.y7k_1;
    var doExpensiveScaling = !get_isLow(tmp0_elvis_lhs == null ? ctx.k5q() : tmp0_elvis_lhs);
    if (this.a7l_1 || !(this.b7l_1 === renderScale)) {
      this.b7l_1 = renderScale;
      this.c7l_1 = this.e7o(VOID, false);
      this.d7l_1 = doExpensiveScaling ? this.s7n().d1().r3c(this.c7l_1.d1()) : Scale.q3c(1);
      this.a7l_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.c7l_1.q2b_1 * renderScale * this.d7l_1.h3b_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.c7l_1.r2b_1 * renderScale * this.d7l_1.i3b_1), 1);
      cache.z7s(texWidth, texHeight);
      ctx.f5i();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.v7s_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.y5q(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.r5g_1;
        var this_1 = this_0.a5h_1;
        if (!(this_1.v5g_1 === this_0)) {
          this_1.v5g_1 = this_0;
          this_1.f5i();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.e49(0, 0, frameBuffer.c3z_1, frameBuffer.d3z_1);
          var temp = this_0.y5h_1;
          this_0.f5o();
          this_0.y5h_1 = scissor;
          try {
            if (true) {
              ctx.r5q(Colors_getInstance().w20_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.d7n().u38(-this.c7l_1.o2b_1, -this.c7l_1.p2b_1).p38(renderScale * this.d7l_1.h3b_1, renderScale * this.d7l_1.i3b_1);
            ctx.f5i();
            var temp4 = ctx.g5g_1;
            var temp2d = ctx.h5g_1;
            ctx.h5g_1 = matrix;
            ctx.g5g_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.r45(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.g47();
              this_2.o4t(_unary__edvuaz + 1 | 0);
              this_2.p4t(this_2.g47() + 1 | 0);
              var blockSize = this_2.k45_1;
              var index0 = imul(this_2.g47() - 1 | 0, blockSize);
              var index1 = imul(this_2.g47(), blockSize);
              var texBlockSize = this_2.h45_1.u4d().d1();
              var texIndex0 = imul(this_2.g47() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.g47(), texBlockSize);
              if (this_2.g47() > 0) {
                arraycopy(this_2.m45_1, index0, this_2.m45_1, index1, blockSize);
              } else {
                arrayfill(this_2.m45_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.h45_1;
              this_2.n45_1.s4t($this$push.t4d(), ctx.g5g_1);
              if (true && this_2.g47() >= 1) {
                var equals = arrayequal(this_2.m45_1, index0, this_2.m45_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.g47();
                  this_2.o4t(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.o7i(ctx);
            }finally {
              ctx.f5i();
              ctx.g5g_1 = temp4;
              ctx.h5g_1 = temp2d;
              ctx.r45(ProjViewUB_getInstance()).q4t();
            }
            break $l$block_0;
          }finally {
            this_0.f5o();
            this_0.y5h_1 = temp;
          }
        }
      }finally {
        ctx.z5q();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.r5g_1;
    var this_4 = this_3.a5h_1;
    if (!(this_4.v5g_1 === this_3)) {
      this_4.v5g_1 = this_3;
      this_4.f5i();
    }
    this_3.h5i(cache.x7s_1, VOID, VOID, VOID, VOID, this.c7n().w38(this.c7l_1.o2b_1, this.c7l_1.p2b_1).r38(1.0 / (renderScale * this.d7l_1.h3b_1), 1.0 / (renderScale * this.d7l_1.i3b_1)), VOID, this.g7n(), this.b70_1);
  }
  f7l() {
    return this;
  }
  g7l(view) {
    this.a7l_1 = true;
    var tmp218_safe_receiver = this.f1r();
    var tmp219_safe_receiver = tmp218_safe_receiver == null ? null : tmp218_safe_receiver.z6z_1;
    if (tmp219_safe_receiver == null)
      null;
    else {
      tmp219_safe_receiver.g7l(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static q7s(size, cache, clip) {
    size = size === VOID ? Size2D.e37(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.t7s(cache);
    $this.n7s_1 = clip;
    $this.o7s_1 = size;
    $this.p7s_1 = Ref(false);
    return $this;
  }
  j7i() {
    return this.o7s_1;
  }
  l7i() {
    return new Rectangle(0.0, 0.0, this.h1j(), this.i1j());
  }
  o7i(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.n7s_1;
      var renderingInternalRef = this.p7s_1;
      if (renderingInternalRef.h3()) {
        super.o7i(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.c7n();
        var hasRotation = !(m.a38_1 === 0.0) || !(m.b38_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.h3();
          try {
            renderingInternalRef.i1o(true);
            renderFiltered(this, ctx, Companion_getInstance_34());
          }finally {
            renderingInternalRef.i1o(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.r5g_1;
        if (!(ctx.v5g_1 === batcher)) {
          ctx.v5g_1 = batcher;
          ctx.f5i();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.t5g_1;
        var bounds = this.w7n(ctx).b3c(ctx.h5g_1).c3c();
        var rect = c2d.c5r_1.p5n().l49();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.w3b(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_22().h49(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.c5r_1;
            var scissor_0 = c2d.k5r(scissor);
            var temp = this_0.y5h_1;
            this_0.f5o();
            this_0.y5h_1 = scissor_0;
            try {
              super.o7i(ctx);
              break $l$block_1;
            }finally {
              this_0.f5o();
              this_0.y5h_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.o7i(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.o7i(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static f7i(size, cache) {
    Companion_getInstance_28();
    size = size === VOID ? Companion_getInstance_28().x7p_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.q7s(size, cache, false);
    $this.d7i_1 = size;
    $this.e7i_1 = false;
    return $this;
  }
  j7i() {
    return this.d7i_1;
  }
  l7i() {
    return new Rectangle(0.0, 0.0, this.h1j(), this.i1j());
  }
  m7i() {
    super.m7i();
    this.n7i();
  }
  n7i() {
    this.i7l();
  }
  o7i(ctx) {
    registerUISupportOnce(this);
    super.o7i(ctx);
  }
}
class SceneContainer extends UIView {
  static l74(views, defaultTransition, name, size) {
    Companion_getInstance_27();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_4())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.k6y_1.d1() : size;
    var $this = this.f7i(size);
    $this.f74_1 = views;
    $this.g74_1 = defaultTransition;
    $this.a70_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.g7i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.v78(this_0);
    tmp.h74_1 = this_0;
    $this.i74_1 = null;
    var tmp_0 = Companion_instance_11;
    $this.r3q(tmp_0, SceneContainer$lambda($this));
    $this.j74_1 = arrayListOf([Companion_getInstance_27().n7c_1]);
    $this.k74_1 = 0;
    return $this;
  }
  qo() {
    return this.f74_1.y6w_1;
  }
  h7i(clazz, injects, time, transition, $completion) {
    this.i7i(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  m74(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.g74_1 : transition;
    return $super === VOID ? this.h7i(clazz, injects, time, transition, $completion) : $super.h7i.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  o7c(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0(this, newScene, time, transition, $completion), $completion);
  }
  i7i(entry) {
    while (this.j74_1.d1() <= this.k74_1) {
      this.j74_1.g(Companion_getInstance_27().n7c_1);
    }
    this.j74_1.v2(this.k74_1, entry);
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static g7i() {
    var $this = this.w78();
    dummyView($this);
    dummyView($this);
    $this.e7f_1 = Companion_getInstance_9().h35_1;
    $this.f7f_1 = get_AlphaTransition();
    return $this;
  }
  x11() {
    return this.f1(0);
  }
  u11() {
    return this.f1(1);
  }
  h7f(next, transition) {
    this.f7f_1 = transition;
    this.e7f_1 = Companion_getInstance_9().h35_1;
    this.g7f_1 = transition.i7o();
    this.j7o(this.u11(), next);
    _get_transitionProcess__5hlux5(this).f7o(this.x11(), this.u11());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.e7f_1) + ':transition=' + toString(this.f7f_1));
  }
  i7f() {
    this.e7f_1 = Companion_getInstance_9().k35_1;
    _get_transitionProcess__5hlux5(this).g7o(this.x11(), this.u11());
    this.j7o(dummyView(this), this.u11());
  }
  j7o(prev, next) {
    this.k7o();
    this.p7l(prev);
    this.p7l(next);
  }
  o7i(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.e7f_1, Companion_getInstance_9().h35_1) <= 0) {
      this.x11().k7i(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.e7f_1, Companion_getInstance_9().k35_1) >= 0) {
      this.u11().k7i(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).h7o(ctx, this.x11(), this.u11(), this.e7f_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.l7o_1 = $render;
    this.m7o_1 = $name;
  }
  i7o() {
    return this;
  }
  h7o(ctx, prev, next, ratio) {
    return this.l7o_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.m7o_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.n7o_1 = $process;
    this.o7o_1 = $easing;
  }
  f7o(prev, next) {
    return this.n7o_1.f7o(prev, next);
  }
  g7o(prev, next) {
    return this.n7o_1.g7o(prev, next);
  }
  h7o(ctx, prev, next, ratio) {
    return this.n7o_1.h7o(ctx, prev, next, this.o7o_1.c35(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.p7o_1 = $this_withEasing;
    this.q7o_1 = $easing;
  }
  toString() {
    return toString(this.p7o_1) + '.withEasing';
  }
  i7o() {
    var process = this.p7o_1.i7o();
    return new withEasing$1$create$1(process, this.q7o_1);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_2.i3o() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_2.i3o() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.r7o_1 = view;
    this.s7o_1 = vs;
    this.t7o_1 = fastTime;
    this.u7o_1 = easing;
    this.v7o_1 = callback;
    this.w7o_1 = c;
    this.x7o_1 = fastWaitTime;
    this.y7o_1 = autoInvalidate;
    this.z7o_1 = Companion_instance_2.h3o();
    var tmp = this;
    var tmp_0;
    if (!equals(this.t7o_1, Companion_instance_2.i3o())) {
      tmp_0 = this.t7o_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.s7o_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.m5s_1);
        destination.g(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.a7p_1 = tmp_0;
    this.b7p_1 = false;
    this.c7p_1 = false;
    this.d7p_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_12;
    tmp_1.e7p_1 = this.r7o_1.r3q(tmp_2, TweenComponent$updater$lambda(this));
    var tmp110_safe_receiver = this.w7o_1;
    if (tmp110_safe_receiver == null)
      null;
    else {
      tmp110_safe_receiver.or(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_2.h3o());
  }
  l7p() {
    return get_slow(this.x7o_1);
  }
  m7p() {
    if (this.d7p_1)
      return Unit_instance;
    this.d7p_1 = true;
    var tmp111_safe_receiver = this.w7o_1;
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp111_safe_receiver.bc(tmp$ret$0);
    }
  }
  k7p() {
    if (this.c7p_1)
      return Unit_instance;
    this.c7p_1 = true;
    var tmp112_safe_receiver = this.e7p_1;
    if (tmp112_safe_receiver == null)
      null;
    else {
      tmp112_safe_receiver.p5();
    }
    this.e7p_1 = null;
    this.m7p();
  }
  f7p(elapsed) {
    if (equals(elapsed, Companion_instance_2.h3o())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.s7o_1;
      var n = 0;
      while (n < this_0.d1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.f1(_unary__edvuaz).h32();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.s7o_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.f1(_unary__edvuaz_0);
      var durationInTween = equals(v.k5s_1, Companion_instance_2.i3o()) ? FastDuration__minus_impl_evs237(this.a7p_1, v.j5s_1) : v.k5s_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.j5s_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7(durationInTween, Companion_getInstance().qi_1) <= 0 || FastDuration__compareTo_impl_4fhnj7_0(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.u7o_1.b35(ratioInTween);
      v.p5s(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.r7o_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.n7p_1 = $this_tween;
    this.o7p_1 = $tc;
    this.p7p_1 = $vs;
    this.q7p_1 = $time;
    this.r7p_1 = $easing;
    this.s7p_1 = $callback;
    this.t7p_1 = $waitTime;
    this.u7p_1 = $autoInvalidate;
  }
  r17($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14(this, $this$withTimeoutNullable, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_16 = this;
    this.v7p_1 = 90.0;
    this.w7p_1 = 32.0;
    this.x7p_1 = Size2D.p3b(90.0, 32.0);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.y7s_1 = $outer;
    this.u7s_1 = ctx;
    this.v7s_1 = this.u7s_1.w5q(16, 16, VOID, VOID, VOID, false);
    this.w7s_1 = TextureBase.h5l(this.v7s_1.g43(), 16, 16);
    this.x7s_1 = Texture(this.w7s_1);
  }
  z7s(width, height) {
    this.v7s_1.i43(0, 0, width, height);
    this.w7s_1.i5l(width);
    this.w7s_1.j5l(height);
    this.x7s_1 = Texture(this.w7s_1);
  }
  p5() {
    this.y7s_1.z7k_1 = null;
    this.u7s_1.x5q(this.v7s_1);
  }
}
class ZIndexComparator {
  a7t(a, b) {
    return compareTo(a.h7m(), b.h7m());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.a7t(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.r7v_1 = this$0;
    this.q7v_1 = 0;
  }
  b1() {
    return this.q7v_1 < this.r7v_1.p7v_1.k7l();
  }
  c1() {
    var _unary__edvuaz = this.q7v_1;
    this.q7v_1 = _unary__edvuaz + 1 | 0;
    return this.r7v_1.p7v_1.m7l(_unary__edvuaz);
  }
  t5() {
    this.q7v_1 = this.q7v_1 - 1 | 0;
    this.r7v_1.p7v_1.o7l(this.q7v_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.o7v_1 = children;
    this.p7v_1 = container;
  }
  f1(index) {
    return this.o7v_1.f1(index);
  }
  r2() {
    return this.o7v_1.r2();
  }
  s2(index) {
    return this.o7v_1.s2(index);
  }
  t2(fromIndex, toIndex) {
    return this.o7v_1.t2(fromIndex, toIndex);
  }
  d1() {
    return this.p7v_1.k7l();
  }
  s7v(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.f1r() === this.p7v_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  q2(elements) {
    return this.s7v(elements);
  }
  g1() {
    return this.p7v_1.k7l() === 0;
  }
  t7v(element) {
    this.p7v_1.p7l(element);
    return true;
  }
  g(element) {
    return this.t7v(element instanceof View ? element : THROW_CCE());
  }
  u7v(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.p7v_1.p7l(element);
    }
    return true;
  }
  e1(elements) {
    return this.u7v(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
}
class DummyView extends View {
  static v7x() {
    return this.w7x();
  }
  o7i(ctx) {
    return Unit_instance;
  }
}
class Companion_3 {}
class FixedSizeContainer extends Container {
  static x7x(size, clip) {
    size = size === VOID ? Size2D.e37(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.w78();
    $this.j7v_1 = clip;
    $this.k7v_1 = size;
    $this.l7v_1 = Ref(false);
    return $this;
  }
  m7v() {
    return this.j7v_1;
  }
  j7i() {
    return this.k7v_1;
  }
  l7i() {
    return new Rectangle(0.0, 0.0, this.h1j(), this.i1j());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.h1j()) + 'x' + get_niceStr(this.i1j()) + ')');
    return out;
  }
  o7i(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.m7v();
      var renderingInternalRef = this.l7v_1;
      if (renderingInternalRef.h3()) {
        super.o7i(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.c7n();
        var hasRotation = !(m.a38_1 === 0.0) || !(m.b38_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.h3();
          try {
            renderingInternalRef.i1o(true);
            renderFiltered(this, ctx, Companion_getInstance_34());
          }finally {
            renderingInternalRef.i1o(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.r5g_1;
        if (!(ctx.v5g_1 === batcher)) {
          ctx.v5g_1 = batcher;
          ctx.f5i();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.t5g_1;
        var bounds = this.w7n(ctx).b3c(ctx.h5g_1).c3c();
        var rect = c2d.c5r_1.p5n().l49();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.w3b(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_22().h49(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.c5r_1;
            var scissor_0 = c2d.k5r(scissor);
            var temp = this_0.y5h_1;
            this_0.f5o();
            this_0.y5h_1 = scissor_0;
            try {
              super.o7i(ctx);
              break $l$block_1;
            }finally {
              this_0.f5o();
              this_0.y5h_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.o7i(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.o7i(ctx);
      }
    }
  }
}
class SContainer extends FixedSizeContainer {
  static k7b(size, clip) {
    size = size === VOID ? Size2D.e37(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.x7x(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.z7x_1 = capacity;
    this.a7y_1 = IntDeque.b1l(this.z7x_1);
    this.b7y_1 = 0;
  }
  d1() {
    return this.a7y_1.d1();
  }
  c7y() {
    return this.a7y_1.d1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.b7y_1 / this.a7y_1.d1());
  }
  d7y() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.c7y());
  }
  e7y(index) {
    return get_fastMicroseconds_0(this.a7y_1.f1(index));
  }
  f7y(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.a7y_1.h1l(intValue);
    this.b7y_1 = this.b7y_1 + intValue | 0;
    if (this.a7y_1.d1() > this.z7x_1) {
      this.b7y_1 = this.b7y_1 - this.a7y_1.sj() | 0;
    }
  }
}
class RectBase extends View {
  static g86(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_3().n35_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.w7x();
    $this.s85_1 = smoothing;
    $this.e86(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.t85_1 = get_Bitmaps_white();
    $this.u85_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_24();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.v85_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.w85_1 = null;
    $this.x85_1 = null;
    return $this;
  }
  y85(v) {
    if (!(this.t85_1 === v)) {
      this.t85_1 = v;
      this.a71_1 = true;
      this.e7l();
    }
  }
  r7s(v) {
    if (!this.u85_1.equals(v)) {
      this.u85_1 = v;
      this.a71_1 = true;
      this.e7l();
    }
  }
  z85() {
    return this.u85_1;
  }
  o83() {
    return 0.0;
  }
  p83() {
    return 0.0;
  }
  y7l() {
    return this.z85().w35_1 * this.o83();
  }
  z7l() {
    return this.z85().x35_1 * this.p83();
  }
  a86() {
    return -this.y7l();
  }
  b86() {
    return -this.z7l();
  }
  o7i(ctx) {
    if (!this.a7n())
      return Unit_instance;
    var tmp = this.t85_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.a71_1) {
      this.a71_1 = false;
      this.d86();
    }
    this.c86(ctx);
  }
  c86(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.r5g_1;
    var this_1 = this_0.a5h_1;
    if (!(this_1.v5g_1 === this_0)) {
      this_1.v5g_1 = this_0;
      this_1.f5i();
    }
    var tmp283_safe_receiver = this.x85_1;
    if (tmp283_safe_receiver == null)
      null;
    else
      tmp283_safe_receiver(ctx);
    var array = this.v85_1;
    var tex = ctx.s5q(this.t85_1).x1z();
    var smoothing = this.s85_1;
    var blendMode = this.f7n();
    var program = this.w85_1;
    var vcount = array.z5n_1;
    var icount = array.a5o_1;
    var matrix = Companion_getInstance_12().w37_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.e5l_1;
      this_0.s5n(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_15().c5n_1 : program;
      if (this_0.h5o(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.k5n();
      if (!contains(this_0.q5h_1, tex_0)) {
        this_0.p5h_1 = 0;
        this_0.q5h_1[0] = tex_0;
      }
      this_0.r5h_1 = smoothing;
      this_0.s5h_1 = blendMode;
      this_0.t5h_1 = pprogram;
    }
    this_0.e5o(array, matrix, vcount, icount);
  }
  d86() {
    this.v85_1.o5r(0, this.a86(), this.b86(), this.o83(), this.p83(), this.c7n(), this.t85_1, this.g7n());
  }
  l7i() {
    return Companion_getInstance_10().n3b(this.a86(), this.b86(), this.o83(), this.p83());
  }
  toString() {
    var out = super.toString();
    if (!this.z85().equals(Companion_getInstance_3().n35_1))
      out = out + (':anchor=(' + this.o7n(this.z85().w35_1) + ', ' + this.o7n(this.z85().x35_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static e83(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_3().n35_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.g86(anchor, hitShape, smoothing);
    $this.a83_1 = false;
    $this.b83_1 = bitmap;
    $this.n83();
    return $this;
  }
  c83(value) {
    if (equals(this.t85_1, value))
      return Unit_instance;
    this.a83_1 = true;
    this.y85(value);
  }
  n2d() {
    return this.t85_1;
  }
  n83() {
    if (this.a83_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  o7i(ctx) {
    this.n83();
    super.o7i(ctx);
  }
  o83() {
    return this.t85_1.h1j();
  }
  p83() {
    return this.t85_1.i1j();
  }
  w3f() {
    return this.t85_1.w3f();
  }
  x3f() {
    return this.t85_1.x3f();
  }
  h3f() {
    return this.t85_1.h3f();
  }
  i3f() {
    return this.t85_1.i3f();
  }
  q83() {
    return this.z85().w35_1 * this.h3f();
  }
  r83() {
    return this.z85().x35_1 * this.i3f();
  }
  y7l() {
    return this.q83() - this.w3f();
  }
  z7l() {
    return this.r83() - this.x3f();
  }
  l7i() {
    return Companion_getInstance_10().n3b(-this.q83(), -this.r83(), this.h3f(), this.i3f());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.n2d()));
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.v6x_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.l83(views, currentVfs, sourceFile, $completion) : $super.l83.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static d83(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_3().n35_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.e83(bitmap, anchor, hitShape, smoothing);
    $this.p80_1 = new Mixin_0();
    $this.q80_1 = sourceFile$factory($this);
    return $this;
  }
  t80(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, this, views, currentVfs, sourceFile, $completion), $completion);
  }
  f83(ctx, view) {
    this.p80_1.f83(ctx, view);
  }
  g83(_set____db54di) {
    this.p80_1.r80_1 = _set____db54di;
  }
  h83(_set____db54di) {
    this.p80_1.h83(_set____db54di);
  }
  i83() {
    return this.p80_1.s80_1;
  }
  static j83(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_3().n35_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.d83(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  static k83(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_3().n35_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.j83(slice(bitmap), anchor, hitShape, smoothing);
  }
  o7i(ctx) {
    this.f83(ctx, this);
    super.o7i(ctx);
  }
  l83(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos(this, views, currentVfs, sourceFile, $completion), $completion);
  }
}
class Stage extends FixedSizeContainer {
  static j6w(views) {
    var $this = this.x7x();
    $this.f6w_1 = views.i6x_1;
    $this.g6w_1 = views;
    $this.h6w_1 = clipBorders$factory($this.j76());
    $this.i6w_1 = virtualSizeDouble$factory($this.j76());
    $this.b7m($this);
    $this.d7m($this);
    return $this;
  }
  h5p(pos) {
    return this.f6w_1.h5p(pos);
  }
  y5o(_set____db54di) {
    this.f6w_1.y5o(_set____db54di);
  }
  z5o() {
    return this.f6w_1.z5o();
  }
  a5p(_set____db54di) {
    this.f6w_1.a5p(_set____db54di);
  }
  b5p() {
    return this.f6w_1.b5p();
  }
  c5p(_set____db54di) {
    this.f6w_1.c5p(_set____db54di);
  }
  d5p() {
    return this.f6w_1.d5p();
  }
  e5p(_set____db54di) {
    this.f6w_1.e5p(_set____db54di);
  }
  f5p(_set____db54di) {
    this.f6w_1.f5p(_set____db54di);
  }
  g5p() {
    return this.f6w_1.g5p();
  }
  j76() {
    return this.g6w_1;
  }
  qo() {
    return this.g6w_1.y6w_1;
  }
  h86(_set____db54di) {
    var this_0 = this.h6w_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  m7v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h6w_1;
    clip$factory_0();
    return this_0.get();
  }
  i86(_set____db54di) {
    var this_0 = this.i6w_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  j7i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i6w_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  z7m() {
    return this;
  }
  f7l() {
    return this;
  }
  g7l(view) {
    this.j76().g7l(view);
  }
  toString() {
    return 'Stage';
  }
}
class ColorReference {}
class Companion_4 {
  l86(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp343_safe_receiver = l;
        l = tmp343_safe_receiver == null ? null : tmp343_safe_receiver.f1r();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp344_safe_receiver = r;
        r = tmp344_safe_receiver == null ? null : tmp344_safe_receiver.f1r();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.m7n(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.p86_1 = $view;
    this.q86_1 = $ctx;
    this.r86_1 = this$0;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15(this, $completion), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.r80_1 = true;
    this.s80_1 = null;
  }
  g83(_set____db54di) {
    this.r80_1 = _set____db54di;
  }
  h83(value) {
    this.r80_1 = false;
    this.s80_1 = value;
  }
  t80(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.h83(sourceFile);
    _this__u8e3s4.g83(true);
  }
  l83(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.cd('An operation is not implemented: ' + reason);
  }
  f83(ctx, view) {
    if (this.r80_1)
      return Unit_instance;
    this.s86(ctx, view);
  }
  s86(ctx, view) {
    if (!this.r80_1 && !(this.s80_1 == null)) {
      this.r80_1 = true;
      launchImmediately_0(ctx.x5f_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.t86_1 = this$0;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16(this, $completion), $completion);
  }
}
class Views extends BaseEventListener {
  static x74(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_15().v5m_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.p3q();
    $this.x6w_1 = new Mixin();
    $this.y6w_1 = coroutineContext;
    $this.z6w_1 = ag;
    $this.a6x_1 = injector;
    $this.b6x_1 = input;
    $this.c6x_1 = timeProvider;
    $this.d6x_1 = stats;
    $this.e6x_1 = gameWindow;
    $this.f6x_1 = gameId;
    $this.g6x_1 = settingsFolder;
    $this.h6x_1 = batchMaxQuads;
    $this.i6x_1 = bp;
    $this.j6x_1 = stageBuilder;
    $this.k6x_1 = quality$factory($this.e6x_1);
    $this.l6x_1 = $this;
    $this.m6x_1 = false;
    $this.n6x_1 = continuousRenderMode$factory($this.e6x_1);
    $this.o6x_1 = new ReshapeEvent(0, 0);
    $this.p6x_1 = new UpdateEvent();
    $this.q6x_1 = new ViewsUpdateEvent($this);
    $this.r6x_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.s6x_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.u6x_1 = null;
    $this.v6x_1 = get_resourcesVfs();
    $this.w6x_1 = get_RegisteredImageFormats();
    $this.x6x_1 = new RenderContext($this.z6w_1, $this, $this.e6x_1, $this.d6x_1, $this.y6w_1, $this.h6x_1, $this.e6x_1);
    $this.y6x_1 = true;
    $this.z6x_1 = Colors_getInstance().s20_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.a6y_1 = HashMap.u7();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.b6y_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.c6y_1 = new Resources($this.y6w_1, $this.v6x_1);
    $this.d6y_1 = false;
    $this.e6y_1 = 1280;
    $this.f6y_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.g6y_1 = ArrayList.j1();
    $this.h6y_1 = Companion_getInstance_2().w3c_1;
    $this.i6y_1 = Companion_getInstance_3().r35_1;
    $this.j6y_1 = true;
    $this.k6y_1 = $this.j6x_1($this);
    $this.l6y_1 = $this.k6y_1;
    $this.m6y_1 = true;
    $this.n6y_1 = false;
    $this.o6y_1 = debugExtraFontScale$factory($this.x6x_1);
    $this.p6y_1 = debugExtraFontColor$factory($this.x6x_1);
    $this.q6y_1 = FastArrayList.j1h();
    $this.r6y_1 = $this.c6x_1.c3o();
    var tmp_4 = $this;
    tmp_4.s6y_1 = Pool.y1m(VOID, Views$tempViewsPool$lambda);
    $this.t6y_1 = SizeInt.d3d();
    $this.u6y_1 = SizeInt.d3d();
    $this.v6y_1 = SizeInt.d3d();
    $this.w6y_1 = new Signal();
    $this.x6y_1 = new Signal();
    $this.y6y_1 = -1.0;
    $this.a6x_1.w2l(getKClass(CoroutineContext), $this.y6w_1);
    $this.a6x_1.w2l(getKClass(AG), $this.z6w_1);
    $this.a6x_1.w2l(getKClass(Views), $this);
    $this.x6y_1.c1h(Views$lambda($this));
    $this.w6y_1.c1h(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.z6y_1 = Companion_instance_4.l1i('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.a6z_1 = new EventResult();
    $this.b6z_1 = new Signal();
    $this.c6z_1 = Companion_getInstance_0().p1a('debugHightlightView');
    $this.d6z_1 = new Signal();
    $this.e6z_1 = new Signal();
    $this.f6z_1 = ArrayList.j1();
    $this.g6z_1 = updatedSinceFrame$factory($this.e6x_1);
    return $this;
  }
  b1i(_set____db54di) {
    this.x6w_1.b1i(_set____db54di);
  }
  c1i() {
    return this.x6w_1.c1i();
  }
  qo() {
    return this.y6w_1;
  }
  g5q() {
    return this.e6x_1.g5q();
  }
  h5q() {
    return this.e6x_1.h5q();
  }
  i5q() {
    return this.e6x_1.i5q();
  }
  j5q() {
    return this.e6x_1.j5q();
  }
  h5p(pos) {
    return this.i6x_1.h5p(pos);
  }
  y5o(_set____db54di) {
    this.i6x_1.y5o(_set____db54di);
  }
  z5o() {
    return this.i6x_1.z5o();
  }
  a5p(_set____db54di) {
    this.i6x_1.a5p(_set____db54di);
  }
  b5p() {
    return this.i6x_1.b5p();
  }
  c5p(_set____db54di) {
    this.i6x_1.c5p(_set____db54di);
  }
  d5p() {
    return this.i6x_1.d5p();
  }
  e5p(_set____db54di) {
    this.i6x_1.e5p(_set____db54di);
  }
  f5p(_set____db54di) {
    this.i6x_1.f5p(_set____db54di);
  }
  g5p() {
    return this.i6x_1.g5p();
  }
  j76() {
    return this.l6x_1;
  }
  i75(_set____db54di) {
    var this_0 = this.n6x_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  c75() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n6x_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  v86() {
    return replace(replace(replace(this.f6x_1, '\\', ''), '/', ''), '..', '');
  }
  g7y() {
    var tmp = this.t6x_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  g2r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk(this, $completion), $completion);
  }
  h75() {
    return this.c6y_1;
  }
  j75() {
    return this.z6w_1.j3z().c3z_1;
  }
  k75() {
    return this.z6w_1.j3z().d3z_1;
  }
  w86(value) {
    this.e6y_1 = numberToInt(value);
  }
  x86() {
    return this.e6y_1;
  }
  y86(value) {
    this.f6y_1 = numberToInt(value);
  }
  z86() {
    return this.f6y_1;
  }
  k86(value) {
    this.w86(value.c37_1);
    this.y86(value.d37_1);
  }
  j86() {
    return Size2D.s3b(this.x86(), this.z86());
  }
  p5() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  u86($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw(this, $completion), $completion);
  }
  y74(_set____db54di) {
    var this_0 = this.o6y_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  a87() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o6y_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  z74(_set____db54di) {
    var this_0 = this.p6y_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  b87() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p6y_1;
    debugFontColor$factory_0();
    return this_0.get().i29_1;
  }
  y7x(block) {
    this.q6y_1.g(block);
  }
  t3q(type, event, result, up, down) {
    event.n3r(false);
    var result_0 = super.t3q(type, event, result, up, down);
    var e = event;
    e.m3r(this.l6x_1);
    if (e instanceof KeyEvent) {
      this.b6x_1.i5k(e);
      this.b6x_1.p5j_1.z5i(e);
      if (e.i3s_1.equals(Type_UP_getInstance_0()) && this.m6y_1 && (e.k3s_1.equals(Key_F12_getInstance()) || e.k3s_1.equals(Key_F7_getInstance()))) {
        this.n6y_1 = !this.n6y_1;
        this.e6x_1.d5x(this.n6y_1);
        this.g7l(this.k6y_1);
      }
    }
    try {
      return this.k6y_1.c3r(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  c87(frameBuffer) {
    this.x6x_1.w5g_1 = frameBuffer;
    if (this.y6x_1) {
      var tmp404_$this = this.x6x_1;
      var tmp405_color = this.z6x_1;
      tmp404_$this.r5q(tmp405_color, 1.0, 0, true, true, true);
    }
    this.w6y_1.d1h(this.x6x_1);
    this.x6x_1.f5i();
    this.k6y_1.k7i(this.x6x_1);
    this.x6x_1.f5i();
    this.k6y_1.r7l(this.x6x_1);
    if (this.n6y_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.q6y_1.i1h_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.x6x_1);
      }
    }
    this.x6y_1.d1h(this.x6x_1);
    this.x6x_1.f5i();
  }
  d87(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.z6w_1.j3z() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.c87(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.c87.call(this, frameBuffer);
    }
    return tmp;
  }
  e87() {
    this.z6w_1.n3z();
    this.d87();
  }
  d75(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.c6x_1.c3o();
    this.l6x_1.d6x_1.n3z();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_25().r6t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.r6y_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.l6x_1.b6y_1) > 0 ? this.l6x_1.b6y_1 : delta;
    this.r6y_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_2.i3o())) {
        this.g87(fixedSizeStep);
      } else {
        this.f87(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.h87() > 0);
    if (doRender2) {
      if (this.z6y_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_7().e3o().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.h87() + ']');
      }
      this.e87();
      this.n3z();
    }
  }
  f87(elapsed) {
    return this.g87(get_fast(elapsed));
  }
  g87(elapsed) {
    this.b6x_1.g5k(elapsed);
    this.a6z_1.q1n();
    updateSingleViewWithViewsAll(this.k6y_1, this, elapsed);
    this.b6x_1.h5k(elapsed);
  }
  b75() {
  }
  g75(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.u6y_1 = SizeInt.x1v(actualWidth, actualHeight);
    this.i87();
  }
  i87() {
    setBoundsInfo(this.i6x_1, Size2D.e37(this.e6y_1, this.f6y_1), toFloat(this.u6y_1), this.h6y_1, this.i6y_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.x6x_1.d5g_1 = this.i6x_1.d5p();
    this.x6x_1.e5g_1 = this.i6x_1.z5o();
    // Inline function 'kotlin.also' call
    var this_0 = this.o6x_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.c3s_1 = this.u6y_1.v1v_1;
    this_0.d3s_1 = this.u6y_1.w1v_1;
    this.c3r(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.r6x_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.m87_1 = this.t6y_1;
    this.c3r(this_1);
    this.k6y_1.i7l();
  }
  n87(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.e6x_1.e5x())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.c6z_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.b6z_1.d1h(viewToHightlight);
  }
  p7c(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.n87(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.n87.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  o87(_set____db54di) {
    var this_0 = this.g6z_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  h87() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g6z_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  n3z() {
    this.e6x_1.n3z();
  }
  g7l(view) {
    this.e6x_1.s5x();
  }
}
class Companion_5 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_2.h3o() : fastDelta;
    super();
    this.r87_1 = views;
    this.s87_1 = fastDelta;
  }
  g3r() {
    return Companion_instance_19;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.s87_1) + ')';
  }
}
class Companion_6 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.x1v(0, 0) : size;
    super();
    this.l87_1 = views;
    this.m87_1 = size;
  }
  g3r() {
    return Companion_instance_20;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.m87_1.toString() + ')';
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.t87_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  u87(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.t87_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_14().j20_1;
}
class RenderToTextureResult {
  constructor() {
    this.y87_1 = null;
    this.z87_1 = 0;
    this.a88_1 = 0;
    this.b88_1 = 0;
    this.c88_1 = 0;
    this.d88_1 = 1.0;
    this.e88_1 = Companion_getInstance_12().v37_1;
    this.f88_1 = null;
    this.g88_1 = null;
    this.h88_1 = null;
    this.i88_1 = null;
  }
  as() {
    if (this.g88_1 == null || this.i88_1 == null)
      return Unit_instance;
    var tmp450_safe_receiver = this.g88_1;
    if (tmp450_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp451_safe_receiver = this.i88_1;
      var tmp;
      if (tmp451_safe_receiver == null) {
        tmp = null;
      } else {
        tmp451_safe_receiver.x5q(tmp450_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.y87_1 = null;
    this.f88_1 = null;
    this.g88_1 = null;
    this.i88_1 = null;
    this.h88_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_34();
    this.j88_1 = smoothing;
  }
  x87(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.r5g_1;
    var this_1 = this_0.a5h_1;
    if (!(this_1.v5g_1 === this_0)) {
      this_1.v5g_1 = this_0;
      this_1.f5i();
    }
    this_0.h5i(texture, VOID, VOID, VOID, VOID, matrix, this.j88_1, renderColorMul, blendMode, Companion_getInstance_15().c5n_1);
  }
}
class Companion_8 extends IdentityFilter {
  constructor() {
    Companion_instance_22 = null;
    super(true);
    Companion_instance_22 = this;
  }
}
class ViewRenderPhaseFilter {}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.q6t($this.g6s_1.p6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.h6s_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_13;
function Companion_getInstance_25() {
  if (Companion_instance_13 === VOID)
    new Companion();
  return Companion_instance_13;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().q1g($this.n6t_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.t6t(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.j6w(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.r17($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_14;
function Companion_getInstance_26() {
  if (Companion_instance_14 === VOID)
    new Companion_0();
  return Companion_instance_14;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.h6z_1.l6s_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.i6z_1.k6y_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_4()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_5().e3d_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.jk();
    var height = size.kk();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp0_elvis_lhs = base == null ? null : base.h1j();
      rwidth = tmp0_elvis_lhs == null ? views_0.k6y_1.h1j() : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = base == null ? null : base.i1j();
      rheight = tmp1_elvis_lhs == null ? views_0.k6y_1.i1j() : tmp1_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.l74(views_0, defaultTransition, name, Size2D.s3b(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).m74($this.h6z_1.l6s_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.j6z_1($this.i6z_1.k6y_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.h6z_1.t6s_1) {
    var tmp_3 = $this.k6z_1.j5x($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.n74_1, $this.o74_1, $this.p74_1, $this.q74_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.r17($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_6().v3m()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().p3o();
    try {
      var tmp0_elvis_lhs = $this.t74_1.b6t_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().s20_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.r74_1, $this.s74_1, $this.t74_1.a6t_1, null, $this.t74_1.s6s_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().p3o();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v5w(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().p3o();
    try {
      try {
        if (!($this.u74_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().l1i($this.u74_1), $this.v74_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.x5w(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_25().r6t_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.k1a(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.j1a(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().p3o();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v5w('setIcon', tmp$ret$5);
    }
  }
  $this$loop.c5x($this$loop.k5q());
  if (Companion_getInstance_6().v3m()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.zb();
  var this_3 = Views.x74(tmp$ret$6.zl(gameWindow.q5w()).zl(new InjectorContext($this.t74_1.n6s_1)).zl(SupervisorJob()), $this.t74_1.i6t_1 ? AGPrint.u4r() : $this$loop.p5w(), $this.t74_1.n6s_1, input, $this.t74_1.m6s_1, stats, gameWindow, $this.t74_1.u6s_1, $this.t74_1.v6s_1, $this.t74_1.w6s_1, VOID, $this.t74_1.l6t_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.g2r($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_6().c1a()) {
    Dyn__set_impl_2ozvx8(Companion_instance_1.p1o(), 'views', this_3);
  }
  var views = this_3;
  $this.t74_1.n6s_1.w2l(getKClass(GameWindow), gameWindow);
  $this.t74_1.n6s_1.w2l(getKClass(Korge), $this.t74_1);
  views.n6y_1 = $this$loop.e5x();
  views.y74($this.t74_1.j6t_1);
  views.z74($this.t74_1.k6t_1);
  views.e6y_1 = numberToInt($this.t74_1.y6s_1.c37_1);
  views.f6y_1 = numberToInt($this.t74_1.y6s_1.d37_1);
  views.i6y_1 = $this.t74_1.z6s_1.r6w_1;
  views.h6y_1 = $this.t74_1.z6s_1.q6w_1;
  views.j6y_1 = $this.t74_1.z6s_1.s6w_1;
  views.y6y_1 = $this.t74_1.m6t_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().p3o();
    try {
      KorgeReload_getInstance().w5e(gameWindow);
      var tmp_4 = KorgeRunner_instance.a75(views, gameWindow, true, $this$loop.b5x(), Companion_instance_2.i3o(), $this.t74_1.f6t_1, $this.t74_1.o6s_1).hr($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().p3o();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v5w(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().p3o();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().p3o();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.v5w(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.t74_1, views, $this.w74_1, gameWindow));
  if ($this.t74_1.t6s_1) {
    var tmp_5 = gameWindow.j5x($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.h5x();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.worker.Companion.init' call
    get_workerImpl().h32();
    if (get_workerImpl().i32()) {
      if (get_DEBUG_WORKER()) {
        println('INSIDE WORKER');
      }
      break $l$block;
    } else {
      if (get_DEBUG_WORKER()) {
        println('**NOT** INSIDE WORKER');
      }
    }
    // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
    get_nativeSoundProvider();
    get_RegisteredImageFormats().b2g([config.j6s_1]);
    var iconPath = config.d6t_1;
    var imageFormats = config.j6s_1;
    var entry = config.h6t_1;
    var windowSize = config.x6s_1;
    if (!Companion_getInstance_6().c1a()) {
      var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().l1i('klogger.properties'), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    var tmp0_elvis_lhs = config.k6s_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      tmp_0 = $completion.zb().mc(CoroutineKey_getInstance());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.g6t_1.l5y(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.a6t_1)) : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = config.b6t_1;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
      tmp_1 = Colors_getInstance().s20_1;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    realGameWindow.a5x(tmp_1);
    var tmp_3 = realGameWindow.k5x(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.h5p(Vector2D.h38(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.d5k(button, true);
  input.c5k(p, false);
  input.c5k(p, true);
  $views.b75();
  downPos._v = input.b5k();
  downTime._v = new DateTime(Companion_getInstance_7().c3o());
  input.n5j_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.d5k(button, false);
  input.c5k(p, false);
  $views.b75();
  upPos._v = $views.b6x_1.b5k();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.b6x_1.c5k(p, false);
  $views.b6x_1.n5j_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.b75();
  moveTime._v = new DateTime(Companion_getInstance_7().c3o());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.b6x_1.c5k(p, false);
  $views.b75();
  moveTime._v = new DateTime(Companion_getInstance_7().c3o());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.v3u_1 = 0;
  mouseTouchEvent.y3u_1 = true;
  mouseTouchEvent.w3u_1 = Companion_getInstance_7().c3o();
  mouseTouchEvent.x3u_1 = false;
  mouseTouchEvent.g3v(type);
  mouseTouchEvent.l3v(button.m3y_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.h3v();
  $views.c3r(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.g3w_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.x5j_1[gamepad.h3w_1].p3w(gamepad);
  }
  input.e5k();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.d75($fixedSizeStep, $views.c75(), event.r3r_1, event.s3r_1);
    $views.b6x_1.m5j_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.b6x_1.m5j_1 = true;
      $views.b6x_1.n5j_1 = false;
      $views.b75();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_25().r6t_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.k1a(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.j1a(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.m6x_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.e75($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_25().r6t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.b3t_1, e.c3t_1, e.m3t_1);
    var tmp_0;
    switch (e.z3s_1.j3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.d3t_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d3t_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.d3t_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d3t_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d3t_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_25().r6t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_25().r6t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.c3r(e);
    get_nativeSoundProvider().v19(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.c3r(e);
    get_nativeSoundProvider().v19(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.c3r(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_25().r6t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.a5k(e);
    var ee = $input.f5j_1;
    var _iterator__ex2g4s = ee.d3v().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.i3u_1 = prepareViewsBase$getRealXY($views, t.n3u(), t.o3u(), e.x3u_1);
    }
    $views.c3r(ee);
    var tmp_0;
    if (ee.e3v() === 1) {
      var start = ee.o3v();
      var end = ee.p3v();
      var t_0 = first(ee.d3v());
      var p = t_0.i3u_1;
      var x = t_0.n3u();
      var y = t_0.o3u();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.a3t_1 = 0;
      this_1.d3t_1 = button;
      this_1.e3t_1 = end ? 0 : 1 << button.m3y_1;
      this_1.b3t_1 = numberToInt(x);
      this_1.c3t_1 = numberToInt(y);
      this_1.m3t_1 = false;
      this_1.n3t_1 = true;
      this_1.z3s_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.c3r(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_25().r6t_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.c3r(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.g75($ag.j3z().c3z_1, $ag.j3z().d3z_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.c3r(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.s3r_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.x6x_1;
      var frameBuffer = this_0.j3z();
      this_0.a5g_1.q1n();
      this_0.t5f_1.n3z();
      var tmp_0;
      try {
        this_0.y5q(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.yu(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.z5q();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.t5f_1.h3v();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_25().s6t_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_15().v5m_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().l5k_1.c37_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().l5k_1.d37_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.e37(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.c37_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.d37_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.e37(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_2().w3c_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_3().z35() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().s20_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().r20_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, Unit_instance)).o6w(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.t6t(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.j6w(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.t6t(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.f1i_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.g1i_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.f1i_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.r75_1.p75_1.o1h($this.s75_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.t75_1.n75_1.o1h($this.u75_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.v75_1.o75_1.o1h($this.w75_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.k3r_1;
    tmp.m75_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.x75().y6w_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.k3r_1;
    tmp.m75_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.x75().y6w_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.k3r_1;
    tmp.m75_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.x75().y6w_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.d1i_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.c1i();
    var tmp101_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp101_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.d1i_1;
      tmp_0 = tmp101_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.e1i_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.d1i_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.d1i_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.u5f_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.i76($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel_0($this.qo());
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.j76().y6w_1.zl(new InjectorContext(this$0.k76())).zl(Job(this$0.j76().y6w_1.mc(Key_instance)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.m76(this$0.l76().d1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.d76_1.v78(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.k76().f2m(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.qo();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.y78();
  }, null);
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var scene = $this.c7c_1.i74_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.c7c_1.i74_1) + ' . doFullReload=' + $this.d7c_1.k7c());
    var tmp;
    if ($this.d7c_1.k7c()) {
      tmp = $this.d7c_1.l7c(getKClassFromExpression(scene), scene.k76());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.c7c_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.g74_1;
    var sceneInjector = this_0.f74_1.a6x_1.y2l().w2l(getKClass(SceneContainer), this_0).w2l(getKClass(Resources), new Resources(this_0.qo(), this_0.f74_1.h75().w2z_1, this_0.f74_1.h75()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.w2l(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.f2m(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.d7c_1.q5e(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_27().m7c_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.k1a(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.j1a(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.h2m(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.f74_1.a6x_1.a2m(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.d7c_1, scene));
    }
    var tmp_5 = this_0.o7c(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.j76().p7c(scene_0.y78());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.f2m($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.q5e($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.q7c_1.y78();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.q7c_1.l7b(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.r7c_1.y78();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.r7c_1.m7b(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.s7c_1.o7b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = $this.t7c_1.p7b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.t7c_1.q7b($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = $this.u7c_1.r7b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.v7c_1.n7b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.f74_1.a6x_1.y2l().w2l(getKClass(SceneContainer), $this).w2l(getKClass(Resources), new Resources($this.qo(), $this.f74_1.h75().w2z_1, $this.f74_1.h75()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.w2l(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.f2m(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_27().m7c_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.k1a(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.j1a(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.h2m(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.f74_1.a6x_1.a2m(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.o7c(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.i74_1;
  $this.i74_1 = newScene;
  $this.h74_1.h7f(newScene.d76_1, transition);
  try {
    var tmp = newScene.qo();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.qo();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.h74_1);
    var initial = Companion_getInstance_9().h35_1;
    var end = Companion_getInstance_9().k35_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.h74_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.h74_1.e7f_1 = Companion_getInstance_9().k35_1;
  }
  $this.h74_1.i7f();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.qo();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.qo();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_15;
function Companion_getInstance_27() {
  if (Companion_instance_15 === VOID)
    new Companion_1();
  return Companion_instance_15;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.i74_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.f2m($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.g35_1, p1.g35_1, p2.g35_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.e7f_1);
  }, function (value) {
    $b0.e7f_1 = value.g35_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.g7f_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.x7m();
  var nextAlpha = next.x7m();
  try {
    prev.w7m(1.0 - Ratio__toFloat_impl_1ftup5(ratio.g35_1));
    next.w7m(Ratio__toFloat_impl_1ftup5(ratio.g35_1));
    prev.k7i(ctx);
    next.k7i(ctx);
  }finally {
    prev.w7m(prevAlpha);
    next.w7m(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_2.i3o() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_2.i3o();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp113_safe_receiver = tc._v;
        if (tmp113_safe_receiver == null)
          null;
        else {
          tmp113_safe_receiver.f7p(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_2.i3o() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion), $completion);
}
function _update($this, dt) {
  if ($this.y7o_1) {
    $this.r7o_1.e7l();
  }
  if ($this.b7p_1) {
    return $this.k7p();
  }
  $this.z7o_1 = FastDuration__plus_impl_q1enab($this.z7o_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.z7o_1, $this.a7p_1), 0.0, 1.0);
  $this.f7p($this.z7o_1);
  $this.v7o_1($this.u7o_1.a35(ratio));
  var tmp;
  var tmp_0 = $this.l7p();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7($this.z7o_1, $this.l7p()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.m7p();
  }
  if (ratio >= 1.0) {
    return $this.k7p();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.a5z_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.b7p_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_2.i3o()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.zb();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0(time, block, $completion), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.gt();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.n7p_1;
  $this.o7p_1._v = new TweenComponent(view, toList($this.p7p_1), $this.q7p_1, $this.r7p_1, $this.s7p_1, cancellable, $this.t7p_1, $this.u7p_1);
  var tmp$ret$0 = cancellable.rq();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.r17($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_4());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.e7i_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.z7m();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.e7i_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_16;
function Companion_getInstance_28() {
  if (Companion_instance_16 === VOID)
    new Companion_2();
  return Companion_instance_16;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.r7s(anchor);
  return _this__u8e3s4;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.m7v();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.v78(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.v7x();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.p7l(this_0);
  return this_0;
}
var Companion_instance_17;
function Companion_getInstance_29() {
  return Companion_instance_17;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().r3o())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.j76().w6y_1;
  tmp.c1h(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.j76().x6x_1).n5p_1;
  tmp_0.c1h(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.j76().x6x_1.r5g_1.z5h_1;
  tmp_1.c1h(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.j76().x6x_1.r5g_1.a5i_1;
  tmp_2.c1h(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.j76();
  tmp_3.y7x(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.v5p_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.n5n() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp239_font = $this_addDebugRenderer.g7y();
  var tmp240_colMul = $ctx.q5g_1;
  var tmp241_blendMode = Companion_getInstance_23().i5f_1;
  drawText($ctx, tmp239_font, fontSize, text, x, y, matrix, tmp240_colMul, tmp241_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.m5q();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().r3o();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.k3o_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7_0(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.f7y(elapsedTime);
        $shortWindow.f7y(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.l6x_1.z5o();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.d7y(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_6().u3m() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.x6x_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.m5p_1;
    if (!(this_2.v5g_1 === this_1)) {
      this_2.v5g_1 = this_1;
      this_2.f5i();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.y5p_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_23().i5f_1;
          var doUpdate = !(this_1.x5p_1 === blending);
          var old = this_1.x5p_1;
          try {
            if (doUpdate) {
              this_1.m5p_1.f5i();
              this_1.x5p_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().h26_1;
            var oldColor = this_1.p5p_1;
            this_1.p5p_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.d5q(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.d5q(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.p5p_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().r20_1 : Colors_getInstance().s20_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.p5p_1;
                this_1.p5p_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.d1() / $longWindow.z7x_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.d1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.d1(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.d1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.d1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.e7y(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.e7y(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.d5q(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.p5p_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.m5p_1.f5i();
            }
            this_1.x5p_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.y5p_1;
  }, function (value) {
    $b0.y5p_1 = value;
    return Unit_instance;
  });
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.p80_1.t80(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.t80($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.l1i('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.c83(tmp_0);
    $this.i7m(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.c83(tmp$ret$0);
      $this.i7m(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.b83_1.c1j();
  if (!(source == null)) {
    $this.a83_1 = true;
    $this.y85(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.i83();
  }, function (value) {
    return $b0.h83(value);
  });
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.j6y_1;
  }, function (value) {
    $b0.j6y_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.j86();
  }, function (value) {
    return $b0.k86(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.m7v();
  }, function (receiver, value) {
    return receiver.h86(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.m7v();
  }, function (receiver, value) {
    return receiver.h86(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.j7i();
  }, function (receiver, value) {
    return receiver.i86(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.j7i();
  }, function (receiver, value) {
    return receiver.i86(value);
  });
}
var Companion_instance_18;
function Companion_getInstance_30() {
  return Companion_instance_18;
}
function updateRenderColorTransform($this) {
  $this.x70_1 = $this.c71_1;
  $this.e71_1 = true;
  var parent = $this.f1r();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.w70_1.d29($this.v70_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.w70_1.e29($this.v70_1, parent.e7n());
    } else {
      $this.w70_1.d29($this.v70_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.x70_1 === $this.c71_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.z70_1 = $this.b71_1;
  $this.d71_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.b70_1.equals(Companion_getInstance_23().z5e_1)) {
    var tmp353_safe_receiver = $this.f1r();
    var tmp0_elvis_lhs = tmp353_safe_receiver == null ? null : tmp353_safe_receiver.f7n();
    tmp_0 = tmp0_elvis_lhs == null ? Companion_getInstance_23().y5e_1 : tmp0_elvis_lhs;
  } else {
    tmp_0 = $this.b70_1;
  }
  tmp.y70_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.z70_1 === $this.b71_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp380_safe_receiver = _this__u8e3s4.f1r();
    var tmp0_elvis_lhs = tmp380_safe_receiver == null ? null : hasAncestor(tmp380_safe_receiver, ancestor);
    tmp = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.o7m(Scale.j3b(sx, sy));
  return _this__u8e3s4;
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.j1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.g(_this__u8e3s4);
    }
    if (_this__u8e3s4.p6z_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp337_safe_receiver = _this__u8e3s4.h7l();
      var tmp_0;
      if (tmp337_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp337_safe_receiver.d1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp337_safe_receiver.f1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.f1r();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.f1r();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.f1r();
  }
  return count;
}
function xy(_this__u8e3s4, x, y) {
  _this__u8e3s4.g7m(x, y);
  return _this__u8e3s4;
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.j7m();
  }, function (value) {
    return $b0.i7m(value);
  });
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.y5p_1;
  }, function (value) {
    $b0.y5p_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.p86_1.m83(ensureNotNull(get_views($this.q86_1)), VOID, $this.r86_1.s80_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.t86_1.u86($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.t6x_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().x5e();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.g6y_1;
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.f1(_unary__edvuaz).y1e($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.g6y_1.z2();
  cancel_0($this.y6w_1);
  $this.e6x_1.i5x();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.j6w(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.g6x_1 == null) ? ensureNotNull(this$0.g6x_1) : StandardPaths_instance.s2u(this$0.v86());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.j1h();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.x6x_1.j5m();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.x6x_1.u5q();
    return Unit_instance;
  };
}
var Companion_instance_19;
function Companion_getInstance_31() {
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_32() {
  return Companion_instance_20;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.p6x_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.a5z_1 = delta;
  _this__u8e3s4.c3r(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.q6x_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.s87_1 = delta;
  _this__u8e3s4.c3r(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_2().z3c() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_3().z35() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.i1o(reqVirtualSize_0);
  targetSize.i1o(scaleMode.c3d(virtualSize.h3(), actualSize_0));
  var ratioX = targetSize.h3().v1v_1 / reqVirtualSize_0.v1v_1;
  var ratioY = targetSize.h3().w1v_1 / reqVirtualSize_0.w1v_1;
  var actualVirtualWidth = toIntRound(actualSize_0.v1v_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.w1v_1 / ratioY);
  _this__u8e3s4.c5p(Companion_getInstance_12().v37_1.r38(ratioX, ratioY).w38(toIntRound((actualVirtualWidth - reqVirtualSize_0.v1v_1 | 0) * anchor.w35_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.w1v_1 | 0) * anchor.x35_1)));
  _this__u8e3s4.y5o(_this__u8e3s4.d5p().x38());
  _this__u8e3s4.e5p(_this__u8e3s4.d5p().y38());
  _this__u8e3s4.a5p(_this__u8e3s4.z5o().y38());
  var tl = _this__u8e3s4.h5p(Vector2D.t37(0, 0));
  var br = _this__u8e3s4.h5p(Vector2D.h38(actualSize_0.v1v_1, actualSize_0.w1v_1));
  _this__u8e3s4.f5p(Companion_getInstance_10().q3b(tl.l36_1, tl.m36_1, br.l36_1, br.m36_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.f2m(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006($completion), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.k5q();
  }, function (value) {
    return $b0.c5x(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.m5x();
  }, function (value) {
    return $b0.l5x(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.p5g_1;
  }, function (value) {
    $b0.p5g_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.q5g_1);
  }, function (value) {
    $b0.q5g_1 = value.i29_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.c5v_1;
  }, function (value) {
    $b0.c5v_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.c75();
  }, function (receiver, value) {
    return receiver.i75(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.c75();
  }, function (receiver, value) {
    return receiver.i75(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.a87();
  }, function (receiver, value) {
    return receiver.y74(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.a87();
  }, function (receiver, value) {
    return receiver.y74(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.b87());
  }, function (receiver, value) {
    return receiver.z74(value.i29_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.b87());
  }, function (receiver, value) {
    return receiver.z74(value.i29_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.t6y_1;
  }, function (value) {
    $b0.t6y_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.v6y_1;
  }, function (value) {
    $b0.v6y_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.h87();
  }, function (receiver, value) {
    return receiver.o87(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.h87();
  }, function (receiver, value) {
    return receiver.o87(value);
  });
}
var renderToTextureResultPool$delegate;
var Companion_instance_21;
function Companion_getInstance_33() {
  if (Companion_instance_21 === VOID)
    new Companion_7();
  return Companion_instance_21;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.z3b(getBorder(_this__u8e3s4, toIntCeil(inp.q2b_1), toIntCeil(inp.r2b_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.w87(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.x1m(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.as();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_22;
function Companion_getInstance_34() {
  if (Companion_instance_22 === VOID)
    new Companion_8();
  return Companion_instance_22;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.h1i_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.f1i_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.f1i_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.g1i_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.f1i_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.e7o(VOID, false);
  if (bounds.q2b_1 <= 0.0 || bounds.r2b_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_33();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.v87();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.u87(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.q2b_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.r2b_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.q2b_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.o2b_1 + edgeSize;
  var addy = -bounds.p2b_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.f5i();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.w5q(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.y5q(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.r5g_1;
      var this_1 = this_0.a5h_1;
      if (!(this_1.v5g_1 === this_0)) {
        this_1.v5g_1 = this_0;
        this_1.f5i();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.e49(0, 0, rb.c3z_1, rb.d3z_1);
        var temp = this_0.y5h_1;
        this_0.f5o();
        this_0.y5h_1 = scissor;
        try {
          if (true) {
            ctx.r5q(Colors_getInstance().w20_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.d7n().u38(addx, addy).q38(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.r5g_1.a5h_1;
          this_2.f5i();
          var temp4 = this_2.g5g_1;
          var temp2d = this_2.h5g_1;
          this_2.h5g_1 = mat;
          this_2.g5g_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.r45(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.g47();
            this_3.o4t(_unary__edvuaz + 1 | 0);
            this_3.p4t(this_3.g47() + 1 | 0);
            var blockSize = this_3.k45_1;
            var index0 = imul(this_3.g47() - 1 | 0, blockSize);
            var index1 = imul(this_3.g47(), blockSize);
            var texBlockSize = this_3.h45_1.u4d().d1();
            var texIndex0 = imul(this_3.g47() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.g47(), texBlockSize);
            if (this_3.g47() > 0) {
              arraycopy(this_3.m45_1, index0, this_3.m45_1, index1, blockSize);
            } else {
              arrayfill(this_3.m45_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.h45_1;
            this_3.n45_1.s4t($this$push.t4d(), this_2.g5g_1);
            if (true && this_3.g47() >= 1) {
              var equals = arrayequal(this_3.m45_1, index0, this_3.m45_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.g47();
                this_3.o4t(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.l7n(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.m7n(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.f5i();
            this_2.g5g_1 = temp4;
            this_2.h5g_1 = temp2d;
            this_2.r45(ProjViewUB_getInstance()).q4t();
          }
          break $l$block_0;
        }finally {
          this_0.f5o();
          this_0.y5h_1 = temp;
        }
      }
    }finally {
      ctx.z5q();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).l3f(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.c7n().w38(-addx, -addy).s38(1.0 / realFilterScale);
    filter.x87(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.g7n(), _this__u8e3s4.b70_1, realFilterScale);
    ctx.f5i();
  }finally {
    ctx.x5q(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp357_safe_receiver = _this__u8e3s4.h71_1;
  var tmp;
  if (tmp357_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp357_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp456_safe_receiver = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp456_safe_receiver == null ? null : tmp456_safe_receiver.k88_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_33().u87(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.h1i_1 = transform;
    filterScale$delegate = this_0;
  }
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_1);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.s7s);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.w78);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.t7s);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.q7s);
initMetadataForClass(UIView, 'UIView', UIView.f7i);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.g7i);
protoOf(Transition$1).f7o = start;
protoOf(Transition$1).g7o = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [Collection, MutableIterable, KtList]);
initMetadataForClass(DummyView, 'DummyView', DummyView.v7x);
initMetadataForCompanion(Companion_3);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.x7x);
initMetadataForClass(SContainer, 'SContainer', SContainer.k7b);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(RectBase, 'RectBase', RectBase.g86);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).m83 = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_4);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).m83 = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_6);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_7);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult);
protoOf(IdentityFilter).v87 = get_recommendedFilterScale;
protoOf(IdentityFilter).w87 = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_17 = new Companion_3();
Companion_instance_18 = new Companion_4();
Companion_instance_19 = new Companion_5();
Companion_instance_20 = new Companion_6();
//endregion
//region block: exports
export {
  tween as tween3jbh5j0ixzsj7,
  views as views17oaxjs1xed1j,
  Korge_0 as Korge11eut3mr7473l,
  Companion_getInstance_27 as Companion_getInstancezug9z9lglek,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Image as Image1b2d7ghyim7p5,
  Stage as Stage1ggtrzujnnkl0,
  addTo as addTo25e29vq105prw,
  anchor as anchor3c5itxst996yy,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  scale as scalea9fc0mbrr7ub,
  xy as xy1gb51vhy014mx,
};
//endregion
